import React, {Component, useRef, useState, useEffect} from "react"
import styled from "styled-components"
import Swal from 'sweetalert2'
import emailjs from 'emailjs-com'
import {CookieNotice} from 'react-cookienotice'
import 'react-cookienotice/dist/style.css'
import Globe from 'react-globe.gl';
import arcsData from "./arcs.json"
import VisibilitySensor from "react-visibility-sensor";
import CountUp from "react-countup"

const Title = styled.h1`
  font-weight: 300;
  font-size: 60px;
    line-height: 72px;
  
  @media screen and (max-width: 700px) {
      font-size: 42px;
      font-weight: 400;
  }
  
  i {
    font-style: normal;
    font-weight: 900;
    background-color: #3b97d3;
    background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255));
    background-size: 100%;
    background-repeat: repeat;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`

const Header = styled.div`
  width: 100%;
  padding-bottom: 128px;
  background: white;
  clip-path: circle(55.0% at 50% 50%);
  user-select: none;

  @media screen and (max-width: 1700px) {
      clip-path: none;
  }
  
  nav {
    padding-top: 96px;

    .container {
      width: 100%;
      padding: 0 64px;
      margin: 0 auto;
      max-width: 1280px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 18px;
      
      @media screen and (max-width: 1400px) {
          box-sizing: border-box;
        
          ul, .right {
              display: none !important;
          }
      }

      button {
        margin-top: 0;
        height: 48px;
        font-size: 18px;
        padding: 0 32px;
      }

      .telephone {
        margin-right: 32px;
        font-weight: 600;
        color: #3b97d3;
        text-decoration: none;
        
        i {
          margin-right: 8px;
        }
      }

      .right {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
      }

      ul {
        li {
          list-style-type: none;
          display: inline-flex;
          margin-right: 16px;
          cursor: pointer;
          padding: 0 14px;
          transition: all 0.3s;
          border-radius: 5px;
          height: 44px;
          align-items: center;
          color: rgba(0, 0, 0, 0.75);

          &:hover {
              background: #3b97d3;
              color: white;
          }
          
          &:last-of-type {
            margin-right: 0;
          }
        }
      }
    }

    img {
      height: 48px;
      
      @media screen and (max-width: 1024px) {
          height: 40px;
      }
    }
  }

  button {
    outline: 0;
    background: #3b97d3;
    //background: linear-gradient(-45deg,#004dbf,#00e1cc);
    color: white;
    width: min-content;
    border: none;
    height: 64px;
    white-space: nowrap;
    padding: 0 32px;
    border-radius: 4px;
    margin-top: 24px;
    font-size: 22px;
    //box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.45);
    font-weight: 400;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.3s;
    
      &:hover {
          background: rgb(220 135 255);
      }
  }



  .telephoneUnder {
    text-decoration: none;
    color: #3b97d3;
    margin-top: 24px;
    font-size: 18px;
    display: none;

    @media screen and (max-width: 1400px) {
      display: block;
    }
  }

  .container {
    width: 100%;
    padding: 0 64px;
    max-width: 1280px;
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    grid-gap: 96px;
    margin: 80px auto 0;

    @media screen and (max-width: 1400px) {
        grid-template-columns: 1fr;
    }

    @media screen and (max-width: 1400px) {
      box-sizing: border-box;
    }
    
    .right {
      display: flex;
      justify-content: center;
      flex-direction: column;
      position: relative;

      > div {
        position: absolute;
        right: -32px;
        top: -80px;
      }
      
      @media screen and (max-width: 1400px) {
          display: none;
      }

      img {
        transform: rotate3d(0.5, -0.8, 0, 20deg);
        width: 100%;
        object-fit: cover;
        height: 80%;
        border-radius: 15px;
        overflow: hidden;
      }
    }

    .left {
      display: flex;
      justify-content: center;
      flex-direction: column;

      ul {
        margin: 8px 0;
        margin-bottom: 16px;

        li {
          display: inline-flex;
          list-style-type: none;
          font-weight: 400;
          margin-right: 24px;
          font-size: 18px;
          align-items: center;

          @media screen and (max-width: 768px) {
            width: 100%;
            margin-bottom: 12px;
            
            i {
                width: 20px;
            }
            
            &:nth-child(3) {
                margin-bottom: 0;
            }
          }
          
          img {
            height: 16px;
            margin-right: 8px;
          }
          
          i {
            margin-right: 8px;
            color: #3ace88;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
`

const Subtitle = styled.h2`
    font-weight: 300;
    opacity: 0.75;
    line-height: 48px;
    font-size: 26px;
    margin: 24px 0;
`

const WorkSections = styled.div`
  padding: 128px 0;
  
  .container {
    width: 100%;
    padding: 0 64px;
    max-width: 1280px;
    margin: 0 auto;

    @media screen and (max-width: 1400px) {
      box-sizing: border-box;
    }
  }
  
  .grid {
      background: white;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 48px;
      border-radius: 10px;
      padding: 48px;
      box-shadow: 0 4px 24px 0 rgb(0 0 0 / 10%);
    
      @media screen and (max-width: 1024px) {
          grid-template-columns: 1fr 1fr;
      }

    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
      
      .workSection {
        padding: 16px 0 !important;
      }
    }
  }
  
  .andMore {
      text-align: center;
      margin-top: 64px;
      font-size: 20px;
      opacity: 0.75;
  }

  h2 {
    font-size: 48px;
    font-weight: 900;
    background-color: #3b97d3;
    background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255), rgb(220 135 255), rgb(220 135 255));
    background-size: 100%;
    background-repeat: repeat;
    -webkit-background-clip: text;
    user-select: none;
    -webkit-text-fill-color: transparent;
  }

  h3 {
    margin-bottom: 64px;
    font-size: 24px;
    font-weight: 300;
    opacity: 0.75;
    user-select: none;
    margin-top: 8px;
  }
  
  .workSection {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 48px 0;
    
      i {
          font-size: 64px;
          color: #3b97d3;
        user-select: none;
      }
    
      p {
          font-size: 20px;
          margin-top: 32px;
          user-select: none;
          font-weight: 400;
      }
  }
`


const HowAbout = styled.div`
  padding: 128px 0;
  
  .container {
    width: 100%;
    padding: 0 64px;
    max-width: 1280px;
    margin: 0 auto;
    position: relative;

    @media screen and (max-width: 1400px) {
      box-sizing: border-box;
    }
    
    .map {
        position: absolute;
        z-index: 1;
        height: 84%;
        top: 5%;
        left: 23%;
        opacity: 0.03;
        -webkit-user-drag: none;
        user-select: none;

      @media screen and (max-width: 1024px) {
        display: none;
      }
    }
    
    .item {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 180px;
        z-index: 2;
      
        @media screen and (max-width: 1024px) {
            flex-direction: column;
          text-align: left !important;
          
          &.right {
            flex-direction: column-reverse !important;
          }
          
          img {
              margin-bottom: 80px;
          }
          
          
            .content {
                margin: 0 !important;
                width: 100% !important;
                max-width: 768px;
            }
        }
      
        &:last-child {
            margin-bottom: 0;
        }
      
        .content {
            width: 50%;
          
            h4 {
                margin-bottom: 24px;
            }
          
            p {
                font-size: 20px;
                line-height: 36px;
                opacity: 0.75;
                font-weight: 300;
            }
        }

      h4 {
        line-height: 48px;
        font-size: 30px;
        font-weight: 300;
        user-select: none;
        
        b {
            font-weight: 900;
          background-color: #3b97d3;
          background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255));
          background-size: 100%;
          background-repeat: repeat;
          -webkit-background-clip: text;
          user-select: none;
          -webkit-text-fill-color: transparent;
        }
      }
      
        img {
            max-height: 300px;
            -webkit-user-drag: none;
            user-select: none;
        }
      
        &.left {
          text-align: right;
            .content {
                margin-left: 64px;
            }
        }
      
        &.right {
          .content {
            margin-right: 64px;
          }
        }
    }
  }
  

  h2 {
    font-size: 48px;
    font-weight: 900;
    background-color: #3b97d3;
    background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255), rgb(220 135 255), rgb(220 135 255));
    background-size: 100%;
    background-repeat: repeat;
    -webkit-background-clip: text;
    user-select: none;
    -webkit-text-fill-color: transparent;
    margin-bottom: 64px;
  }
`

class DartComponent extends Component {
    state = {
        active: null
    }

    render() {
        return <Dart>
            <div className="container">
                <div className="dart">
                    <div className={`box topLeft ${this.state.active === 0 ? "active" : ""}`} onMouseEnter={() => this.setState({ active: 0 })} onMouseLeave={() => this.setState({ active: null })}>
                        <img src="/circle_cut_out.svg" />
                        <div className="content">
                            <div className="text">
                                <div className="floatCircle" />
                                <p>
                                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr.
                                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={`box topRight ${this.state.active === 1 ? "active" : ""}`} onMouseEnter={() => this.setState({ active: 1 })} onMouseLeave={() => this.setState({ active: null })}>
                        <img src="/circle_cut_out.svg" />
                        <div className="content">
                            <div className="text">
                                <div className="floatCircle" />
                                <p>
                                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr.
                                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={`box bottomLeft ${this.state.active === 3 ? "active" : ""}`} onMouseEnter={() => this.setState({ active: 3 })} onMouseLeave={() => this.setState({ active: null })}>
                        <img src="/circle_cut_out.svg" />
                        <div className="content">
                            <div className="text">
                                <div className="floatCircle" />
                                <p>
                                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr.
                                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={`box bottomRight ${this.state.active === 2 ? "active" : ""}`} onMouseEnter={() => this.setState({ active: 2 })} onMouseLeave={() => this.setState({ active: null })}>
                        <img src="/circle_cut_out.svg" />
                        <div className="content">
                            <div className="text">
                                <div className="floatCircle" />
                                <p>
                                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr.
                                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={`circle-1 ${this.state.active === 0 ? "active" : ""}`} onMouseEnter={() => this.setState({ active: 0 })} onMouseLeave={() => this.setState({ active: null })}>
                        <div className="number">1</div>
                        <div className="number">1</div>
                        <div className={`circle-2 ${this.state.active === 1 ? "active" : ""}`} onMouseEnter={() => this.setState({ active: 1 })} onMouseLeave={() => this.setState({ active: 0 })}>
                            <div className="number">2</div>
                            <div className="number">2</div>
                            <div className={`circle-3 ${this.state.active === 2 ? "active" : ""}`} onMouseEnter={() => this.setState({ active: 2 })} onMouseLeave={() => this.setState({ active: 1 })}>
                                <div className="number">3</div>
                                <div className="number">3</div>
                                <div className={`circle-4 ${this.state.active === 3 ? "active" : ""}`} onMouseEnter={() => this.setState({ active: 3 })} onMouseLeave={() => this.setState({ active: 2 })}>
                                    <div className="number">4</div>
                                    <div className="number">4</div>
                                    <div className="circle-5">
                                        <img src="/icon.svg" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dart>
    }
}


const NewsArticle = styled.div`
    width: 100%;
    padding-top: 128px;
    padding-bottom: 160px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    

    button {
        background: #3b97d3;
        color: white;
        outline: 0;
        border: none;
        height: 48px;
        padding: 0 24px;
        border-radius: 5px;
        font-size: 18px;
        display: flex;
        align-items: center;
        user-select: none;
        cursor: pointer;
        transition: all 0.3s;
        margin-top: 24px;
        
        i {
          margin-right: 10px;
        }
        
        &:hover {
          background: rgb(220 135 255);
        }
    }
  
    .container {
      width: 100%;
      padding: 0 64px;
      max-width: 1280px;
      margin: 0 auto;
      
      .inner {
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        @media screen and (max-width: 1024px) {
            flex-direction: column-reverse;
          
            .left {
                margin-right: 0 !important;
            }
          
            .right {
                width: 100% !important;
                margin-bottom: 32px;
                max-width: 600px;
              
                img {
                    transform: none !important;
                }
            }
        }
        
        .left {
          margin-right: 80px;

          p {
            line-height: 40px;
            font-size: 20px;
            font-weight: 300;
            
            b {
              font-weight: 900;
              color: #3b97d3;
            }
          }

          h3 {
            font-size: 44px;
            font-weight: 900;
            color: #20242b;
          }
          
          h4 {
            margin-top: 4px;
            color: #20242b;
            font-size: 24px;
            font-weight: 300;
            margin-bottom: 16px;
          }
        }

        .right {
          display: flex;
          flex-direction: column;
          text-align: right;
          width: 42%;
          flex-shrink: 0;
          perspective: 2000px;

          img {
            width: 100%;
            overflow: hidden;
            border-radius: 10px;
            transform: rotate3d(0, 1, 0, -16deg);
            box-shadow: 2px 2px 14px 0 rgba(0, 0, 0, 0.075);
            padding: 8px;
            background: white;
            -webkit-user-drag: none;
            user-select: none;
          }

          p {
            margin-top: 18px;
            font-size: 14px;
            margin-right: 8px;
            font-weight: 300;
          }
        }
      }
      
      

      @media screen and (max-width: 1400px) {
        box-sizing: border-box;
      }
    }
`


const SuccessStory = styled.div`
    width: 100%;
    background: white;
    padding-top: 128px;
    padding-bottom: 128px;
    margin-bottom: 128px;
    position: relative;
    overflow: hidden;

  .background {
    position: absolute;
    z-index: 1;
    width: 1024px;
    height: 1024px;
    left: 0;
    top: 0;
    transform: translate(-50%, -50%);

    @media screen and (max-width: 1024px) {
        left: unset;
        right: 0;
      transform: translate(50%, -50%);
    }

    .circleOuter {
      width: 100%;
      height: 100%;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .circleInner {
      width: 70%;
      height: 70%;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .planet {
      width: 70%;
      height: 70%;
      background: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255));
      border-radius: 100%;
    }
  }
  
    button {
        background: #3b97d3;
        color: white;
        outline: 0;
        border: none;
        height: 48px;
        padding: 0 24px;
        border-radius: 5px;
        font-size: 18px;
        display: flex;
        align-items: center;
        user-select: none;
        cursor: pointer;
        transition: all 0.3s;
        margin-top: 24px;
        
        i {
          margin-right: 10px;
        }
        
        &:hover {
          background: rgb(220 135 255);
        }
    }
  
    .container {
      width: 100%;
      padding: 0 64px;
      max-width: 1280px;
      margin: 0 auto;
      position: relative;
      z-index: 3;
      
      .inner {
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        @media screen and (max-width: 1024px) {
            flex-direction: column;
          
            .left {
                margin-right: 0 !important;
            }
          
            img.logo {
                display: none;
            }
        }
        
        img.logo {
          width: 20%;
          filter: grayscale(1);
          opacity: 0.3;
        }
        
        .left {
          margin-right: 80px;

          p {
            line-height: 40px;
            font-size: 20px;
            font-weight: 300;
            font-style: italic;
            
            &.customer {
                font-style: unset;
                margin-top: 16px;
                display: flex;
                align-items: center;
              
                .flex {
                    line-height: 28px;
                  
                    div {
                        font-size: 16px;
                    }
                }
              
                b {
                    color: #3b97d3;
                    margin-right: 8px;
                }
              
                img {
                    width: 48px;
                    height: 48px;
                    border-radius: 100%;
                    margin-right: 12px;
                }
            }
            
            b {
              font-weight: 900;
              color: #3b97d3;
            }
          }

          h3 {
            font-size: 44px;
            font-weight: 900;
            color: #20242b;
          }
          
          h4 {
            margin-top: 4px;
            color: #20242b;
            font-size: 24px;
            font-weight: 300;
            margin-bottom: 16px;
            line-height: 44px;
          }
        }
      }
      
      

      @media screen and (max-width: 1400px) {
        box-sizing: border-box;
      }
    }
`

const Dart = styled.div`
    width: 100%;
    padding-bottom: 128px;
    padding-top: 64px;
  
    .container {
      width: 100%;
      padding: 0 64px;
      max-width: 1280px;
      margin: 0 auto;
      display: flex;
      justify-content: center;

      @media screen and (max-width: 1400px) {
        box-sizing: border-box;
      }
      
      .dart {
          width: 75%;
          padding-top: 75%;
          position: relative;
        
          .circle-1 {
              position: absolute;
              width: 45%;
              height: 45%;
              border-radius: 100%;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              background: white;
              box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
          }
        
          .circle-2 {
              background: #E5E5E5;
          }
        
          .circle-3 {
              background: #CECECE;
          }

        .circle-4 {
          background: #B9B9B9;
        }

        .circle-5 {
          background: #20242b;
          display: flex;
            align-items: center;
            justify-content: center;
          
            img {
                width: 55%;
            }
        }
        
          .circle-2, .circle-3, .circle-4, .circle-5 {
              width: calc(100% - 80px);
              height: calc(100% - 80px);
              position: absolute;
              top: 40px;
              left: 40px;
              border-radius: 100%;
          }
        
          .circle-1, .circle-2, .circle-3, .circle-4, .circle-5 {
              cursor: pointer;
              transition: all 0.3s;
            
              .number {
                  position: absolute;
                  top: 6px;
                  left: 50%;
                  transform: translateX(-50%);
                  font-weight: bold;
                  font-size: 24px;
                  transition: all 0.3s;
                  opacity: 0.25;
                  user-select: none;
              }
            
              .number:nth-child(2) {
                  top: unset;
                  bottom: 2px;
              }
            
              &.active {
                  background: #20242b;
                
                  > .number {
                      color: white;
                      opacity: 1;
                  }
              }
          }
        
          .box {
            position: absolute;
            width: 50%;
            height: 50%;
            filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.1));
            user-select: none;
            transition: all 0.3s;
            opacity: 0.75;
            text-align: justify;
            
            &.active {
                opacity: 1;
                transform: scale(1.025);
            }
            
            .content {
                position: absolute;
                z-index: 3;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
              
                .text {
                    width: 100%;
                    height: 100%;
                    box-sizing: border-box;
                    font-size: 16px;
                    line-height: 26px;
                }
              
                .floatCircle {
                    width: 100%;
                    height: 100%;
                    float: right;
                    shape-outside: circle(50% at 100% 100%);
                    shape-margin: 24px;
                }
            }
            
            img {
                width: 100%;
                height: 100%;
                position: absolute;
                user-select: none;
                -webkit-user-drag: none;
            }
            
            &.topLeft {
                top: 0;
                left: 0;

              .content .text {
                padding: 32px calc(2.5% + 32px) calc(2.5% + 32px) 32px;
              }
              
                img {
                    top: 0;
                    left: 0;
                }
            }

            &.topRight {
                top: 0;
                right: 0;

              .content .text {
                padding: 32px 32px calc(2.5% + 32px) calc(2.5% + 32px);
              }
              
                .content .floatCircle {
                    float: left;
                    shape-outside: circle(50% at 0% 100%);
                }

              img {
                top: 0;
                right: 0;
                transform: rotate(90deg);
              }
            }
            &.bottomLeft {
                bottom: 0;
                left: 0;

              .content .text {
                padding: calc(2.5% + 32px) calc(2.5% + 32px) 32px 32px;
              }

              .content .floatCircle {
                shape-outside: circle(50% at 100% 0%);
              }

              img {
                bottom: 0;
                left: 0;
                transform: rotate(270deg);
              }
            }
            
            &.bottomRight {
                bottom: 0;         
                right: 0;

              .content .text {
                padding: calc(2.5% + 32px) 32px 32px calc(2.5% + 32px);
              }

              .content .floatCircle {
                float: left;
                shape-outside: circle(50% at 0% 0%);
              }

              img {
                bottom: 0;
                right: 0;
                transform: rotate(180deg);
              }
            }
          }
      }
    }
`

const World = () => {
    const globeEl = useRef();

    useEffect(() => {
        // Auto-rotate
        globeEl.current.controls().enabled = true;
        globeEl.current.controls().enablePan = false;
        globeEl.current.controls().enableZoom = false;
        globeEl.current.controls().object.position.z = 320
        globeEl.current.controls().autoRotate = true;
        globeEl.current.controls().autoRotateSpeed = 0.5;
    }, []);
/*
    const N = 10;
    const arcsData = [...Array(N).keys()].map(() => ({
        startLat: (Math.random() - 0.5) * 180,
        startLng: (Math.random() - 0.5) * 360,
        endLat: (Math.random() - 0.5) * 180,
        endLng: (Math.random() - 0.5) * 360,
        color: ["#dc87ff", "#3b97d3"]
    }));

    console.log(JSON.stringify(arcsData))
*/
    const gData = arcsData.map(arc => ({
        lat: arc.endLat,
        lng: arc.endLng,
        maxR: 10,
        propagationSpeed: 5,
        repeatPeriod: 1000
    }));

    return <Globe
        width={600}
        height={600}
        animateIn={true}
        globeImageUrl="/earth-night.jpg"
        bumpImageUrl="//unpkg.com/three-globe/example/img/earth-topology.png"
        ringsData={gData}
        atmosphereColor="#3b97d3"
        ringColor={() => "#3b97d3"}
        ringMaxRadius={7}
        ringPropagationSpeed={2.5}
        ringRepeatPeriod={1000}
        backgroundColor="#ffffff"
        enablePointerInteraction={false}
        arcsData={arcsData}
        arcColor={'color'}
        arcDashLength={() => 0.5}
        arcStroke={1.5}
        arcDashGap={() => 0.25}
        arcDashAnimateTime={() => 8000}
        ref={globeEl}
    />
};


export default class extends Component {
    state = { privacyChecked: false, name: null, phone: null, email: null, company: null, message: null }

    render() {
        return <>
            <FeatureModal onRef={ref => this.featureImplementation = ref} title="Implementierungsleitfaden" subtitle="Mit unseren einfachen Rechnungstools verwaltest du deine Faktura kinderleicht - und verlierst dabei nie den Überblick." features={[
                "Rechnungen schreiben & verschicken",
                "Mahnungen schreiben & verschicken",
                "Gutschriften schreiben & verschicken",
                "Offene Posten einsehen und summieren (Umsatz oder Ertrag)",
                "Sammelgruppen erstellen, um viele Aufträge summiert abzurechnen",
                "Teil- & Abschlagsrechnungen generieren",
                "Rechnungen in Sekundenschnelle aus Aufträgen generieren",
                "Schnittstelle zu Factoringanbietern"
            ]} img="/feature_invoices.svg" />
            <FeatureModal onRef={ref => this.featureServiceProviders = ref} title="Dienstleister" subtitle="Führen Sie eine Liste von Dienstleistern und verwalten Sie derer Zuständigkeiten in Ihren Liegenschaften." features={[
                "Dienstleister anlegen, Ansprechpartner pflegen und Zuständigkeiten verwalten",
                "Vertragsverhältnisse und derer Kosten durch diesen Dienstleister definieren",
                <>Datenaufnahme outsourcen und digital kollaborieren, indem der Dienstleister per <b>scanmetrix Mission</b> (kostenlos) oder der <b>scanmetrix Handwerkersoftware</b> verknüpft wird.</>
            ]} img="/feature_service_providers.svg" />
            <FeatureModal onRef={ref => this.featureContracts = ref} title="Vertragswesen" subtitle="Die interne Stammdatenverwaltung ermöglicht die Pflege und Verwaltung von gängigen Datensätzen." features={[
                "Verträge anlegen, archivieren und pflegen",
                "Kündigungsfristen, autom. Vertragsverlängerungen und Verlängerungsoptionen im Auge behalten und Kündigungen vorformulieren",
                "Leistungszyklen definieren und Kosten hinterlegen",
                "Erbrachte Leistungen nachhalten und überfällige Dienstleistungen analysieren",
                "Vertragliche Zuständigkeitsbereiche erfassen",
                "Dokumentenablage und Dokumentation",
                "Bezug zu Dienstleistern herstellen",
                "Automatische Hinweise zu vertraglichen Dokumentationslücken (bspw. fehlende Instandhaltungsverträge an Liegenschaften)"
            ]} img="/feature_contracts.svg" />
            <FeatureModal onRef={ref => this.featureTGA = ref} title="TGA-Aufnahme" subtitle={<>Für die TGA-Aufnahme in Ihren Liegenschaften haben wir eine offlinefähige App (PWA) entwickelt: <b>scanmetrix Mission</b>.</>} features={[
                "Technische Komponenten erfassen, optional mit Verortung via QR Code",
                "Bilder Ihrer Anlagen aufnehmen",
                "Hersteller und Modellbezeichnungen zuordnen",
                "Mängel erfassen und Reparaturen dokumentieren",
                "Wartungen und Prüfungen durchführen",
                "Instandhaltungsintervalle definieren",
                "Objekte verorten und nach Gebäuden strukturieren",
                "Datenaufnahme durch Dienstleister im Rahmen der Wartung durchführen lassen"
            ]} img="/feature_tga.svg" />
            <FeatureModal onRef={ref => this.featureDocuments = ref} title="Dokumente" subtitle="Mit unserem Dokumentensystem verwalten und archivieren Sie Ihre Dateien, Berichte und Dokumentationen rechtssicher." features={[
                "Anlegen von Ordnern & Hochladen von Dateien per Drag and Drop",
                "Feste Ordnerstrukturen standardisiert für Liegenschaften vorgeben",
                "Automatisierte Ablagestrukturen verwenden, die selbstständig Ordner für bestimmte Datensätze anlegen",
                "Dateien rechtssicher und hochverfügbar speichern",
                "Freigabe von Ordnern und Dateien für das eigene Unternehmen und Ihren Kollegen"
            ]} img="/feature_documents.svg" />
            <FeatureModal onRef={ref => this.featureInvoices = ref} title="Rechnungslauf-/prüfung" subtitle="Rechnungseingangsbelege von Dienstleistern und Auftragnehmern digital empfangen und erfassen." features={[
                "Rechnungsbelege digital, per Schnittstelle, per E-Mail oder via eigener Systeme entgegennehmen",
                "Rechnungen auf Belegbasis erfassen und mögliche Fehler identifizieren",
                "Rechnungen sachlich und auf Plausibilität prüfen",
                "Gegenüberstellung von Rechnungen zu POs (Bestellungen) und Vertragsverhältnissen",
                "Anbindung der FI-Buchhaltung mit Freigabeworkflow",
                "Zahlungsausgänge nachhalten",
                "Kosten analysieren und nachkalkulieren"
            ]} img="/feature_invoices.svg" />
            <FeatureModal onRef={ref => this.featureBudget = ref} title="Budgetierung" subtitle="Intelligente Tools zur Kostenplanung, Gegenüberstellung von Soll & Ist sowie intuitive Budgetierungstools." features={[
                "Jahresbudgets definieren",
                "Phasing-Mechanismen nutzen",
                "Benutzerdefinierte Planzahlen erfassen (bspw. für außerplanmäßige Wartungen & Reparaturen)",
                "Soll-Kosten aus Vertragsverhältnissen übernehmen",
                "Ist-Kosten aus Rechnungslauf oder FI-Schnittstelle importieren",
                "Rückstellungsbedarf analysieren und Budgetengpässe vermeiden",
                "Kosten- & Budgetentwicklung vorausschauend auswerten"
            ]} img="/feature_budget.svg" />
            <FeatureModal onRef={ref => this.featureWorkflows = ref} title="Workflows" subtitle="Unser Workflow-Editor ermöglicht die individuelle Erstellung von Prozessvorgaben, die in verschiedenen Durchführungsperspektiven ausgeführt werden können." features={[
                "Baukasten-ähnliche Zusammenstellung von individuellen Workflows / Prozessen",
                "Durchführung von Workflows aus Sicht eines Nutzers, einer Liegenschaft oder einer Arbeitsgruppe",
                "Diverse Automatismen, welche die Workflows intelligent gestalten können",
                "Automatische Auslösung von Workflows durch bestimmte Aktionen",
                "Aufgabenarchiv für bereits durchlaufene Workflows"
            ]} img="/feature_workflows.svg" />
            <FeatureModal onRef={ref => this.featurePlugins = ref} title="Flexible Schnittstellen" subtitle="scanmetrix bietet zahlreiche Schnittstellen und Plugins an, um unser System nahtlos an Ihre IT anzubinden." features={[
                "Diverse Partnerschaften mit namreichen SaaS-Anbietern",
                "Offene Schnittstelle als REST-API oder per GraphQL",
                "Zahlreiche Verbindungen zu bspw. DABBEL, Loxone, Google Workspace uvm.",
                "Die Möglichkeit, Ihre eigenen Systeme anzubinden"
            ]} img="/feature_plugins.svg" />
            <CookieNotice descriptionLabel='Wenn Sie auf "Akzeptieren" klicken, erklären Sie sich damit einverstanden, dass unsere Website Cookies verwendet, um Ihnen die bestmögliche Erfahrung zu bieten, indem Ihre Cookie-Einstellungen gespeichert werden.' declineButtonLabel="Ablehnen" cookieTextLabel="Diese Webseite benutzt Cookies um ein optimales Nutzungserlebnis zu garantieren." acceptButtonLabel="Akzeptieren" readMoreButtonLabel="Mehr erfahren" />
            <div style={{ background: "linear-gradient(45deg, rgb(59, 151, 211), rgb(201 117 235))", position: "relative", zIndex: 2, boxShadow: "0 8px 14px 0 rgba(0, 0, 0, 0.05)" }}>
            <Header>
                <nav>
                    <div className="container">
                        <img src="/logo_text_black.svg" alt="Unser Logo auf hellem Hintergrund" />
                        <ul>
                            <li onClick={() => this.featuresRef.scrollIntoView({ behaviour: "smooth", block: "start" })}>Funktionen</li>
                            <li onClick={() => this.pricingRef.scrollIntoView({ behaviour: "smooth", block: "start" })}>Preise</li>
                            <li onClick={() => window.open("https://handwerk.scanmetrix.io/", "_blank")}>Für Handwerker</li>
                        </ul>
                        <div className="right">
                            <a href="tel:+4920898969000" className="telephone"><i className="fas fa-phone" /> 0208 - 98 96 9000</a>
                            <button onClick={() => this.contactRef.scrollIntoView({ behaviour: "smooth", block: "start" })}>Kontaktieren</button>
                        </div>
                    </div>
                </nav>
                <div className="container">
                    <div className="left">
                        <Title><i>Kollaboratives CAFM</i> für Ihre Liegenschaften</Title>
                        <Subtitle>
                            Smarte Digitalisierung für Ihr technisches Facility Management - zentral oder dezentral.
                        </Subtitle>
                        <ul className="usps">
                            <li><i className="fas fa-lock" /> SSL-verschlüsselt</li>
                            <li><i className="fas fa-badge-check" /> DSGVO-konform</li>
                            <li><img src="/german_flag.svg" /> Made in Germany</li>
                        </ul>
                        <button onClick={() => this.contactRef.scrollIntoView({ behaviour: "smooth", block: "start" })}>Jetzt Kontakt aufbauen</button>
                        <a href="tel:+4920898969000" className="telephoneUnder">oder telefonisch unter <i className="fas fa-phone" /> 0208 - 98 96 9000</a>
                    </div>
                    <div className="right">
                        <World />
                    </div>
                </div>
            </Header>

        </div>
            <HowAbout>
                <div className="container">
                    <img src="/map.svg" className="map" />
                    <h2>Wie wäre es...</h2>
                    <div className="item right">
                        <div className="content">
                            <h4>...wenn Sie bei Ihren 10 Liegenschaften mit je 30 Gewerken bei über 10.000 TGA Objekten den <b>Überblick</b> behielten?</h4>
                            <p>Egal ob Sie eine, hundert oder zweitausend Liegenschaften betreiben; scanmetrix skaliert automatisch mit Ihren Bedürfnissen mit. Wir kennen die Problematik von Filialisten, Logistikern, Hotellerie und Industrie nur zu gut: Altbestand oder gemietete Immobilien sind oft intransparent und daher schwer, in ein CAFM Portal zu implementieren.</p>
                        </div>
                        <img src="/illustrations/one.svg" />
                    </div>
                    <div className="item left">
                        <img src="/illustrations/two.svg" />
                        <div className="content">
                            <h4>...wenn Ihre Facility Manager nicht mehr <br /><b>70% und mehr</b> ihrer Zeit im Auto verbringen müssten, um Ihre Liegenschaften anzufahren?</h4>
                            <p>Inbesondere, wenn Sie überregional aufgestellt sind, werden Sie folgender Problematik begegnen: Lange Anfahrtswege zu Ihren Liegenschaften, die eine Kosten-Nutzen-Diskussion häufig nicht rechtfertigen. Steigende Mobilitätskosten und Inflation dezimieren die ohnehin schon geschmälerte Arbeitszeit Ihrer Facility Manager.</p>
                        </div>
                    </div>
                    <div className="item right">
                        <div className="content">
                            <h4>...wenn Sie mit gleichem Personal im FM mehr als die <b>doppelte Menge</b> an Liegenschaften verwalten könnten?</h4>
                            <p>Intransparente Dokumentation, papierhafte Berichte und Personalfluktuation erschweren den Alltag jedes Facility Managers. Undefinierte Prozesse, langwierige Kommunikationskanäle und unklare Aufgabenbereiche potenzieren dieses Problem. Es sind klare Workflows, intuitive Tools und effiziente Auswertungen, die Ihnen kostbare Zeit wertschöpfen.</p>
                        </div>
                        <img src="/illustrations/three.svg" />
                    </div>
                    <div className="item left">
                        <img src="/illustrations/four.svg" />
                        <div className="content">
                            <h4>...wenn Sie Ihre <b>Betreiberhaftung</b> nie wieder aus den Augen verlieren könnten?</h4>
                            <p>Das Haftungsrisiko ist nach wie vor der zentrale Ankerpunkt des technischen Facility Managements. Doch bei stetig wandelnden Normen, vielfältigen Risiken und großen Mengen an zu verwaltenden Daten ist es oft schwierig, einen Überblick über mögliche Haftungslücken und Verantwortungen zu behalten - und diesen entgegenzuwirken.</p>
                        </div>
                    </div>
                    <div className="item right">
                        <div className="content">
                            <h4>...wenn Sie sicherstellen könnten, dass Ihre Dienstleister nur die <b>Leistungen</b> abrechnen, die sie auch <b>erbringen</b>?</h4>
                            <p>Rechnungsprüfung gestaltet sich auf Grund der dynamischen Natur handwerklicher Tätigkeiten oft schwierig: Die Rechnungsstellung kann auf Basis eines Rahmen- bzw. Dienstleistungsvertrags oder auch einer Bestellung (PO) erfolgen. Eine Gegenüberstellung zu den tatsächlich geforderten Leistungen gestaltet sich daher oftmals komplex; Resultat ist eine Überbelastung Ihres Budgets - oder Ihres Personals.</p>
                        </div>
                        <img src="/illustrations/five.svg" />
                    </div>
                    <div className="item left">
                        <img src="/illustrations/six.svg" />
                        <div className="content">
                            <h4>...wenn Sie die Entwicklung Ihres Facility Management <b>Budgets</b> jederzeit verfolgen und steuern könnten?</h4>
                            <p>Gerade in Zeiten von hoher Inflation, Materialengpässen und Ressourcenmangel ist eine transparente Kostenplanung essenziell - steigende Dienstleistungskosten sind dabei noch das kleinste Übel.<br />Ein automatischer, flexibler Forecast und feste Budgets helfen Ihrem Facility Management, auch in finanziellen Belastungssituationen handlungsfähig und risikooptimiert zu operieren.</p>
                        </div>
                    </div>
                </div>
            </HowAbout>
            <ModuleFacts>
                <div className="container">
                    <div className="grid">
                        <Counter description="Digitalisierte Liegenschaften" value={5000} />
                        <Counter description="Geklebte QR-Codes" value={33500} />
                        <Counter description="Integrierte Verträge" value={1500} />
                        <Counter description="Kundenzufriedenheit" value={100} suffix=" %" />
                    </div>
                </div>
            </ModuleFacts>
            <Cooperations>
                <div className="container">
                    <h2>Unsere Kooperationen</h2>
                    <h3>Starke Kooperationspartner für eine smarte Software.</h3>
                    <div className="logos">
                        <a href="https://zia-deutschland.de/"><img alt="ZIA" src="/logos/zia.svg" /></a>
                        <a href="https://www.bauindustrie-nrw.de/"><img alt="Baunindustrieverband NRW" src="/logos/bauindustrie.svg" /></a>
                        <a href="https://www.dabbel.eu/"><img alt="Dabbel" src="/logos/dabbel.svg" /></a>
                        <a href="https://cloud.ionos.com/"><img alt="IONOS" src="/logos/ionos.svg" /></a>
                        <a href="https://www.symproject.com/"><img alt="SymProject" src="/logos/symproject.svg" /></a>
                    </div>
                </div>
            </Cooperations>
            {/*<WorkSections>
                <div className="container">
                    <h2>Zielgruppen</h2>
                    <h3>scanmetrix richtet sich an Handwerksbetriebe, die Servicedienstleistungen wie Wartungen oder Instandhaltungen vornehmen - dazu gehören insbesondere die folgenden Gewerke.</h3>
                    <div className="grid">
                        <div className="workSection">
                            <i className="fad fa-fire-extinguisher" />
                            <p>Brandschutz</p>
                        </div>
                        <div className="workSection">
                            <i className="fad fa-air-conditioner" />
                            <p>Kälte-/Klimatechnik</p>
                        </div>
                        <div className="workSection">
                            <i className="fad fa-hose" />
                            <p>Löschwassertechnik</p>
                        </div>
                        <div className="workSection">
                            <i className="fad fa-wind" />
                            <p>Lüftungstechnik</p>
                        </div>
                        <div className="workSection">
                            <i className="fad fa-plug" />
                            <p>Elektrik & Meldezentralen</p>
                        </div>
                        <div className="workSection">
                            <i className="fad fa-bolt" />
                            <p>Blitzschutz</p>
                        </div>
                        <div className="workSection">
                            <i className="fad fa-heat" />
                            <p>Heiztechnik</p>
                        </div>
                        <div className="workSection">
                            <i className="fad fa-escalator" />
                            <p>Personenbeförderungsanlagen</p>
                        </div>
                        <div className="workSection">
                            <i className="fad fa-pipe-circle-check" />
                            <p>Sanitäranlagen</p>
                        </div>
                    </div>
                    <div className="andMore">...und alle Handwerksbetriebe, die zyklische Dienstleistungen bei Ihren Kunden erbringen.</div>
                </div>
            </WorkSections>*/}
            <Features ref={ref => this.featuresRef = ref}>
                <div className="container">
                    <h2>Diese Funktionen warten auf Sie</h2>
                    <h3>Nur einige der zahlreichen Funktionen, die scanmetrix zu bieten hat.</h3>
                    <div className="features">
                        <div className="feature">
                            <div className="icon">
                                <i className="far fa-handshake-simple" />
                            </div>
                            <div className="right">
                                <div className="title">Implementierungsleitfaden</div>
                                <div className="subtitle">Assistierte Datenerhebung und progressive Qualitätsverbesserung</div>
                                <div className="learn" onClick={() => window.open("/Implementierungsleitfaden.pdf", "_blank")}>Beispiel herunterladen <i className="far fa-download" /></div>
                            </div>
                        </div>
                        <div className="feature">
                            <div className="icon">
                                <i className="far fa-user-tie" />
                            </div>
                            <div className="right">
                                <div className="title">Dienstleister</div>
                                <div className="subtitle">Dienstleister anbinden, verwalten und TGA-Digitalisierung outsourcen</div>
                                <div className="learn" onClick={() => this.featureServiceProviders.open()}>Mehr erfahren <i className="far fa-arrow-right" /></div>
                            </div>
                        </div>
                        <div className="feature">
                            <div className="icon">
                                <i className="far fa-file-contract" />
                            </div>
                            <div className="right">
                                <div className="title">Vertragswesen</div>
                                <div className="subtitle">Verträge, Leistungsintervalle und Kündigungsfristen administrieren</div>
                                <div className="learn" onClick={() => this.featureContracts.open()}>Mehr erfahren <i className="far fa-arrow-right" /></div>
                            </div>
                        </div>
                        <div className="feature">
                            <div className="icon">
                                <i className="far fa-cog" />
                            </div>
                            <div className="right">
                                <div className="title">TGA-Aufnahme</div>
                                <div className="subtitle">Gebäudeausrüstung aufnehmen, verorten und Instandhaltung überwachen</div>
                                <div className="learn" onClick={() => this.featureTGA.open()}>Mehr erfahren <i className="far fa-arrow-right" /></div>
                            </div>
                        </div>
                        <div className="feature">
                            <div className="icon">
                                <i className="far fa-folder-tree" />
                            </div>
                            <div className="right">
                                <div className="title">Dokumente</div>
                                <div className="subtitle">Dokumentationen und Dateien archivieren, freigeben und verwalten</div>
                                <div className="learn" onClick={() => this.featureDocuments.open()}>Mehr erfahren <i className="far fa-arrow-right" /></div>
                            </div>
                        </div>
                        <div className="feature">
                            <div className="icon">
                                <i className="far fa-coins" />
                            </div>
                            <div className="right">
                                <div className="title">Rechnungslauf/-prüfung</div>
                                <div className="subtitle">Eingangsbelege erfassen, sachlich prüfen und an FI weiterleiten</div>
                                <div className="learn" onClick={() => this.featureInvoices.open()}>Mehr erfahren <i className="far fa-arrow-right" /></div>
                            </div>
                        </div>
                        <div className="feature">
                            <div className="icon">
                                <i className="far fa-piggy-bank" />
                            </div>
                            <div className="right">
                                <div className="title">Budgetierung</div>
                                <div className="subtitle">Kostenentwicklung verfolgen, Rückstellungsbedarf analysieren</div>
                                <div className="learn" onClick={() => this.featureBudget.open()}>Mehr erfahren <i className="far fa-arrow-right" /></div>
                            </div>
                        </div>
                        <div className="feature">
                            <div className="icon">
                                <i className="far fa-project-diagram" />
                            </div>
                            <div className="right">
                                <div className="title">Workflows</div>
                                <div className="subtitle">Prozesse definieren, verknüpfen, triggern, durchführen und nachhalten</div>
                                <div className="learn" onClick={() => this.featureWorkflows.open()}>Mehr erfahren <i className="far fa-arrow-right" /></div>
                            </div>
                        </div>
                        <div className="feature">
                            <div className="icon">
                                <i className="far fa-puzzle-piece" />
                            </div>
                            <div className="right">
                                <div className="title">Flexible Schnittstellen</div>
                                <div className="subtitle">Integrationen und Schnittstellen zu Ihrem FI, BI, AD, SSO sowie vielen weiteren</div>
                                <div className="learn" onClick={() => this.featurePlugins.open()}>Mehr erfahren <i className="far fa-arrow-right" /></div>
                            </div>
                        </div>
                        {/*<div className="feature">
                            <div className="icon">
                                <i className="far fa-house-signal" />
                            </div>
                            <div className="right">
                                <div className="title">Smart Building</div>
                                <div className="subtitle">Energiekosten optimieren, auswerten und CO² reduzieren powered by DABBEL</div>
                                <div className="learn" onClick={() => this.featureFieldService.open()}>Mehr erfahren <i className="far fa-arrow-right" /></div>
                            </div>
                        </div>*/}
                    </div>
                    <button onClick={() => this.contactRef.scrollIntoView({ behaviour: "smooth", block: "start" })}>Alle Funktionen entdecken</button>
                </div>
            </Features>
            {/*<DartComponent />*/}
            <SuccessStory>
                <div className="container">
                    <div className="inner">
                        <div className="left">
                            <h3>Success Story: Crafty GmbH</h3>
                            <h4>Die Crafty GmbH betreut Hotellerie und Gewerbe bundesweit in allen Bereichen des technischen Facility- und Property Managements.</h4>
                            <p>„Das CAFM von scanmetrix hilft uns maßgeblich im Handling des Implementierungsprojektes unseres Kunden; über 50 Standorte, in ganz Deutschland verteilt, mit über 500 Verträgen und unzählbar vielen TGA. Ohne die prozessbasierte Datenerhebung des Systems hätten wir solch einen Strom an Daten niemals aufnehmen und verwalten können. Insbesondere das Outsourcing der TGA-Aufnahme spart uns kostbare Personalressourcen und versetzt uns in die Lage, unserem Kunden konkurrenzfähige Preise anzubieten.”</p>
                            <p className="customer">
                                <img src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoHCBIPEhISEhIKEhIKDxkPDwoKDx8JCggZJSEnJyUhJCQpLjwzKSw4LSQkNDo0ODE1NzY2KDFISEgzPzw0Nz8BDAwMDw8QEA8QEjErGB0/MTs/PzU/PzE/MT8/PzQxMTExMTExMTExMTQxNDExMTExNDExMTExMTExMTExMTExMf/AABEIAMgAyAMBIgACEQEDEQH/xAAbAAACAgMBAAAAAAAAAAAAAAAEBQMGAAECB//EADsQAAEDAgQDBgMIAgAHAQAAAAEAAhEDIQQSMUEFUWEGEyJxgfAykbEjQlKhwdHh8RRiFTNDU3KSoiT/xAAZAQADAQEBAAAAAAAAAAAAAAAAAQIDBAX/xAAiEQEBAAICAgICAwAAAAAAAAAAAQIREiEDMUFRE2EicYH/2gAMAwEAAhEDEQA/APUxifEWwPCLGbErYrk2IALbTMtchHFhBGaCTLmkTnW3V2tsWzyhsFcV+UbEUnNYfFlF9dVG+qSSAZk+EC2VCOxGQggNJeNHfC0IzKXtzBrGy2zg6xSk6ONveXTMkNgEts1qWcX4hToMdUfoyzRo5/QKTGPexkkgDkHXXmXafjb69TLm+zpE5WAy2dyrxmxOw3G+I1MU9z3kN5MF8g5JLiWn+eamxGIDoAt53Llw1hcef6rSrk2Ccw+Y0WhTTmngDsDdd/8ACX8vRLaphSLJ75rktI2Tp/DSNiPOyHfgyPcFLauFLYXOVGuwxC4GGKZcQ4Z75LbWzb5dUV/jHkVjMMeR/RLZ8f0EiPei2zwnofSUS6kfei0KVtPy0QOKJwGo0OnNEcJ4g/DVWVWa03XY74ag3BURZaDuoiCCN725FHtOUezUcX37G1G5cr2hzcl23UoG8aLz7stxKo14ol7g2p8DZzNBV5NJ2md07jko9J9C46eagqPuOi4FJ06uO2tlxVwzhuB1JkpBK0+IaRPzWLVHDaGZg3bFliozJ5dmIEwXb3hMmG7Q0sJd8TolyDe+HF3h8JNtnKRmJDQSNbGISs2yFtyOgAAlpjOBcFaxTmhpDdjBazwpdQxUOc4NIBOaBYKek8OzEuE1DBZuiYhW+2GKNOmGDMM2onKXBeZYsjMTNvmVeO3eJLqjW6imy2xlUQUy8n6mwWk6i5EVJpLh7hWbhvD5AJHVL+G8OlwJIkX81bsLRLWj2FGVb+PFHQwgGyJFAcgpA3ZdtaVO3TjihdhGnb9kPU4a0iICYtC7A+SNr4SkL+DNdsFqnwRo2/lWBzek/VY330RsTCfRGeDN5fwuanCALAaqxM9P3XYaDsPolyVwn0qL+Bc7od3A3NGkg2gW9VdgwcvTmu2ZTqL9RonyTfFHnGJ4URaL8tCUor0CzzG3JeuVsKxwjKL+qqPGeDxJA10GoTmTHPxfSnMqOYWPaSHMPhcLFpC9V4JjWYmhTqBwL4ioNCwrzGrRLHFpFxcA7qydi8aGVH0TEVhmZOoITrlyx0vLiLTEj1JXLiDudNOS6INrBaxVsukgfdQlPgsWWw0AFs3kSSsQVJxJHXcrEGaYt9/CPhdFrNcVwaLs2UZ52dPgeFpjiXPNyGHxx8LFsVYggvaWafh5o/xk5ZSey5yjnlOYBTsgkkDaJA8KFa+XE5pFTURlLUYKha0mNORgt9EB572xf/8AodqPANpcVWgIjn+YVm7bvDsQHifGwW2VaBk2GqqNce9HvBaJJBP7qzMYICV8Fp5WCdfnKazoorrwmo6bTvopMn9LgPt7la7xJtimaxd92oGV/eqmZiAUmjbqfL+lEWuHNFA+91iRh29R+imaF1K6adv6KRsbSJ00+imZT5haZCna4JJqB1P+ELiMMH6380dUcPeyFrPHvdBKJ2kwIY/MBpYkWISnA1O7r06gg5HA6eFytHaYAtn+iqnggXOAH4hC1nccflx1a9RY/PBBgETKx9GRMknbqtBvhb8IIABaLBq0LWJmPQJuZ0xhEAx6iFihfWM8xuNVpAOmYOo6RLWBxJ5Z0LVYWESLEZoJlryjQ7O1xcGuGaZpnbyWOwTARDyWuGYEaMS2zJWATq4crXRVQkgDNdxiNS5bfRAktM2nxeFzkK5pc4QD5xZMKj2yZlqNJuSyJ1BSzhNHvX6Wb8k57ZMINMkR4SDOyG7M04pF/wCNxvzRW/jm9HtIZYA2siWutfVCseNTtul+P4kGSAST0uFLp3o1fVtr+qGfXt7CrFTitSZmQPSFCOMGbn5bI4qmcWn/ACvfJdMxXX+FUzxeen0UzOJk8v3RxVj5YuVHFHp+6nOKG/8AKrOBx2aAUwdU3S02xylNjjI93CwYxI/8iLn6oerxMNtN0tDlIsoxnUdApKeJ66/kqmOLNBRtDiLT94dUaHOLPSfI9yosQPP9AgsPxBkWcPpCJqYprm2I+amwt7V3tI77NIeA0c9amP8Aafkn3GG56bgLxdA9j6Geo9x/6bddwtMfTl83tcnPBIJOu2sKB7wND5dVrOAYMm3khKtQ6C31CpyJhVMkki9liBPOTPVYg9LfVa1pIpksIdBZUPxk62RlOs5hIINRrtNg1Vo4hwqFwcAWvkZxmCb4biFQggMa8vBBgQW/JKs9j6tGm92YnJpYiAEsL2Bxi7Wk5nN0PRGOc5hfnZPeMEVAIaqxxbFvZTqOgNzWblsluqwx5ZSA+2lVlakwtbBpHXdg5FCcGhuGp9Qem6B75zsPUDzIa3wk3IR+AbFCmLTk+Sdrs4TG6jeJfDSJ+I/NAOw4Mz81NXqFuv8ASVY/Fv0bM8xchIaTPpUxrHruga9Gkd6YPR0FAvp1HGX5oOsGXFQPwRJNqkTZwuXKpCt/Sd2GbNn/AJypqWGI+8D0QzcMGgmKk/dvKkwzngwQRuJ0KKcNMICHDafkrDRolwsDEa6pVwxmYgn+VbcHRGXTbXkoyrowx6VfidJzJ5bqvvzHmeu6vvG8MMsxEj0VIxlTJMbJ41OUBVG1J0UlLvf9h6woXPcYcDF4jcLuniarZMWb+MRKrTLc2Z4c1G85+cpjhuJFlnT67JVS4nByvbB/1uigWvuDqprSfo0fVzi2jx5onsRhC5lRwn4r8yEsw5AsNAE47L8RbQaxpOU1CfE27rlL4rLzY3KdHnEWBnduGWYIIbo/ql9VoJBNp6aKao/NAsO7BM6ueoKs63giRKrGONxWY2CdC0fNYo3guaT+e6xPQ2bMYM7mOlrqjsrXPFjdG0QylAa4G2UuzQ5hQnFQBAgCC45z8TkvZLYEk5ryJDXBL2hYKed9Muc5zmHSn8bpQfaCi19B1MtqAzmY6p4SyNUbh3900Zo8LwG9045n9FzxTFtflZfyqWe1EkXheNleeYmmWYdwjxVTEeqbYdmVoHJoQ3FKfjptvBfEDRMKYv5eqTvvd2Hr4WRKWvwgEyPndWMER7CgxFEHRCuO1ZeyJtP6ISpbRplWB9DooRhSdh+pT2OCv5Hu2gIrDYNx10+qfUeHAGXf0u30hMDRLZzD7DYKlkI89FZMMYaISVrL6aJvhm2F9fySbYxzxkzTHUKm4zCkSYmfUBXrHMDqYgxHyKRdyCYIsVO9HljuKm0AGHNF+khStw9MwQGg6iNlY8RwkG4AM7c0M3ho5Eeivky4fcI6mADjzPMbIjC4V4MbfknTeHnb5xCOpYOGyf5U2nx0SsYWzKTseWVG3+F0DorJjWZfeirxZmcIF+8IEbp4kvtLEtLDI8VRohw23UGUny26KKicoA1gBpUoctpi8y+6xjBcEu00CxbAPzWJ8SPuLMaSAXWzkuY2HuPql1Koyi5tQu7yPug5HM20U+PrF8ucZcCR4RkDkhxkd2XB4zF2Xu9T5rHH6I4Zi875lzWZ5a5vhLVPxiqC9hAgRDb5i5VzAYhwe0iJZeHXaUypVc7/ABXy3E3DSjWjxm7IhxmFM5nCMrszVDmuFNi6hc43sB6IdwsOvpCHoT4Th/5fmpGEGxQ7StsPP9oQ1ic0wf3Fl0KIG1vouGPj0+a2+rPu6FRzWIHJAurSfd11iavvRDYZwgkxr8kCiWAk6/sm+HLQ0CfXcqt0+I03PLGPBcBOT8SYCuQIkDpug8ab1aeamb3bccilIblInmtHHEAyfTZDHE5gT6jdTV7PKRBta9/JdOw4PLXUXSjC4mPcpvSrSEaLTh1MN9woar43PiGmwU1V59EBiHn9UiA8QeCEt4ZQ+0BNwHF/kica/Vb4cwguJ3bZaY/Dn8t1LTZpRDwNt0Ex6JEyLgjL8MXlbPOqVoj3qsWF1x5LEwI4gCWlocJLyXAWAS5mBDpvJ1ObwtaicRVuZ/EejnXULqktsNXAGNXLCE1SZTDW3ALiQ4NbJZ1KZYHAh7XFpDn5CfC7KyiNp6nkkrDmcYEZReLBO+y9E1HOJy5KZDi2fC47Iy6mzxurKUhxLnMIiAZG+q3VFh7lW3jeHYabnBjA/MM1TKBUd/CqlYQpl3Hbhly7RA++a7B+fLWFEXreYaptolzj3ZQVqvsrh74ugn4gAyT80LmWoJInX+Unx73MkNIIOyKr43LHLUpVicXMnnoDdORnlkEoO+0DzZ9MyCNlYWYwPgkjTyVcFTy6kalE0X2PL81Viccr2J4li83hBgDUC2dGcFY54AJiNG6kpHmBcR185TPhuPawgHUkAx8LkrFY599ndZhYZjf0TLB1ZGqXV8Y1zbx5jVcYSv1t8lDaZHdV8pZiSiu9keygcS76IO0vxZ29hT4J5ktPL5IeqMzgOZhGUKRZJJkutbRqvGenL5spJdiMmXXzuVNTfogMgvqpabojotXDTUuAIJtb0WLhkOANliomsRLXOgfES0j4ibrZp5IBbBzGQTdxAUmKa9suNvtCyYghTYik1kSczsgfewdKxGhPDOFivmqODKbHg5MrsoBHmjaVLupazEYctd8ZaAGsCg7OUw7M1xYG5SJcMzSehXWN4YKRYwvaS/4O6YC6Z1Kdx3DMqjGPoPipnyOEGZg2/dVLGNy67Kxtx1OjTdTqupCpUFgxxqVHHaRskPEmkiY1CnLHWnR4epSskStOcNOa5j3qsd73Q6JQ2LqQkWIxRJgXvA2R/GKpaB56aJBVeQRFzpOoahNy+B4BeDJtt/stuwWaOUeUKChhazrh5jllF0ZTw1Xdzp/3bnameOO/bG8NFvE3qp6fDhu5kb3XDqNaIDqf/qZ+qwUa53p897oazGfTKmAaJgtKg/xMoM87Ik0quh7s+TS5QVcPX+6QN/hskWWEcmsRI+tgiuHYiXRM28wlGJ7xhhxBJ1gZQEVwkHvGxMG5PJKzpEysq0McAN1DXdqsc5Q1HSk1tRUj4weRlMwd0uos1Pspixtlrj6cHmy3lUDxPoZWmP8Ay/Jac6CVqmRdWxMcM6QFi4oPAAPJYmSfiOOL3FuYEZy7KJDWlNcFhGV7vrU2RTEZjLnKrYmoS905bPIhoyzdSF5cYbmOaGhouXKeIei8KoYdpDG1aNRwkhrSC4oTthxEYek7JHeFuUOHxNHIIrs3wYYannfBq1B4ib9yOX7qnduMVNRwJsXR0Huy0mMkVPapOq1HuzF7heRBhW+lW7ymDu5uZU0PMGfRPuEYj7Nsn4SfIXWWePTbC9pajYPKNua5fbr9Qpq0Ek6yoTp7ss2pHxcTcecckFw/Ch5l2p15hF8VBHr+S44e9rTB39Sj4EvZvQp5Bt06qKrjg2wAMc7kIthDwIjS28IethBBtJP5oa/0HPEWjUNnfoFG7izNg2/PVLsThHZtHeI+RKiw+DcTEEwfkmOWR7R4jm2FuiIGIDxMaqHBYC0lvlzKKq0wxvLoFNaS35K+KYcEGw+kIXhTId5b8lLjsRIIB0/+lDwoXLp1sj4Y2/yOHO/jaFw5uaANSYA5rTef5I7ANpg95UDy1tg2nZzil6LPPjLVhZwyj3dBjsmWlepUaYdUJFx81FV4d39Rww7C2nThs1DlBO+qIw+KYGkljQA2W5RnqpfQxVZlM1I+zL/FmsHkpYXLtwcrd2kuPpGnUcwlpLDBLDnaVAw3RfEq5qGXU2sP3e7GRoCAYYK6Me9Axpmw/wDJYuKRsPNYqASuftH/APmfM3V+7Idn8gbiKzfG69Om7/pDmeqzhXY8Mq97Xcx+Vxc2gwZmEzaSforgrkDh+h8l5F2yqfa30zE38yvXamh8l5P204dVrVGdyzM6SCJyjUop4quMQ3Q/0meAfFMEfiKT4nhNel/zH4Jjv+3nNWqfQaeqZcMaW04JBN7iwWed6bYzs2ZWkLAeqXZyFKKpMLLTWVBxqnDQdwbbgpPh2uBOszoE8xLc4HMaA2aUsdScyZ1nbQpwvkwwtRzYk6i/RHtrtcANZtOgCRNebambZdICnovMEzqdAji0xyM6jWSIgu2m4asAawyAJfrFyEGXiQd9Suc9jf4tDuEtK5G/+QMu06ckux+JkRBteZkqAPsTqJtyQ1V5cedo8kuJ3LoLjyCJGp+RRHCmeCeZ+aGyF1om+1y1McNTFNoE+e6plPdEAwNf4Vic6n/jMBFmHLmYLsPMqm4nFAVKdMH43XV37NBrwGPDXNd4XMfdpVTHcZeS76dYYZKZLozBtp8TUTRxlJ7Q2oIaTnLCcjSU8fwCm6DTe9kaMf8AaNCU8R7KYl921KL+Tf8AlO+iy/Dlty6LuLsGJE06d6Z+LMGiPJVlzCxxBsW2INi1WR3BsfStlqAD7zXgsQv/AACs4lzjTBdcue/M4rTHePVq8cbS+g60LE3pdn3DWowT+EFy0n+TH7Vwr1BYsWLdDh+h8lQu0VPOyq0FwLmuylpyOB1Cv5CpnHMP4zyzX9UHHlDGQfqdU1wJ8McihMdR7qrUYfuPMdRsu8E+JCwydOPwMrDlp9FC1xapnuUTklJqbwd109gdYiR9EHmi6IZWSJoYNs2Otzm1KiGEeJtM3teUe0h3Ky6E+fVMA2UDycZFzFwuBSMkQ6NRawTMErRJQorNB4sNCb8guBhPxO20bqExf6/RD1Hhvu6AiDGt0EfUobEYiAQP6XGIxGsJXiauvuU5Ct0lwA7ysahu2gIHIleh9nJievqqd2fwctEj4jmdzKv3A8PDSdsxWutRje9rXhsRYI1laUjpPi3JF06yrGsrDQlC4hlM/EGX3HgJXAqZtSfS0qOq5o5J2SzuCdIH4Cmfhe8HkTnCxYPFt+yxZfix+lcsvtYFixYtENFIONYeSfKeixYnA827V4Ute18Rm8D/ADGnvoktAwVixZZ+3Rh6hiy/r6Lbme91tYs2qJ9NQlhHT6FYsQTpryPcKVlchYsQaX/LPIfRcvxS2sQIFq4o9UJUeSsWIhULUkhQ4bDmo+Pusu7k7otrFWKclz4Rhi1skeRKuXDaOWm3qJWLFrl6jGe0zhB6H8l01yxYpgqRtTquswfoQfIytrFUSJp0VixYrJ//2Q==" />
                                <div className="flex">
                                    <b>Dustin Maisel</b>
                                    <div>Head of Technology der Crafty GmbH</div>
                                </div>
                            </p>
                        </div>
                        <img className="logo" src="/logos/crafty.svg" />
                    </div>
                </div>

                <div className="background">
                    <div className="circleOuter">
                        <div className="circleInner">
                            <div className="planet" />
                        </div>
                    </div>
                </div>
            </SuccessStory>
            {/*<DeviceWrapper />*/}
            <ESG>
                <div className="container">
                    <h2>ESG-Maßnahmen</h2>
                    <h3>Wir bringen Sie näher an Agenda 2030.</h3>
                    <div className="column">
                        <h4>Environmental</h4>
                        <ul>
                            <li>
                                <i className="fas fa-car" />
                                CO²-Einsparung durch Vermeidung überflüssiger oder doppelter Anfahrten
                            </li>
                            <li>
                                <i className="fas fa-copy" />
                                Papierlose Dokumentation durch digitale Transformation
                            </li>
                            <li>
                                <i className="fas fa-house-signal" />
                                Energiemanagement und Smart Building für die aktive CO²-Reduktion
                            </li>
                        </ul>
                    </div>
                    <div className="column">
                        <h4>Social</h4>
                        <ul>
                            <li>
                                <i className="far fa-user-helmet-safety" />
                                Erfüllung von Arbeitsschutzrichtlinien, höhere betriebliche Sicherheit
                            </li>
                            <li>
                                <i className="far fa-bell-on" />
                                Bessere SLA bei Problemen und höhere Immobilienbewirtschaftung
                            </li>
                            <li>
                                <i className="far fa-chart-user" />
                                Höhere Flexibilität und Entlastung Ihres FM-Personals
                            </li>
                        </ul>
                    </div>
                    <div className="column">
                        <h4>Governance</h4>
                        <ul>
                            <li>
                                <i className="far fa-gavel" />
                                Erfüllung gesetzlicher Auflagen und Einhaltung von Normen
                            </li>
                            <li>
                                <i className="far fa-shield-keyhole" />
                                Transparenz, zentralisierte Dokumentation und Standardisierung
                            </li>
                            <li>
                                <i className="far fa-diagram-subtask" />
                                Prozessorientierung und vorgeschriebene Betriebsstrukturen
                            </li>
                        </ul>
                </div>
                </div>
            </ESG>
            <CallToAction>
                <div className="container">
                    <div className="background" />
                    <div className="content">
                        <div className="left">
                            <img src="/devices.png" alt="Screenshots der Software auf einem Laptop und einem Tablet" />
                        </div>
                        <div className="right">
                            <h3>Nie wieder um Hardware kümmern. Wirklich.</h3>
                            <p>Da scanmetrix eine Cloudlösung ist, müssen Sie sich nie wieder um Installationen, Updates oder Hardwarebeschaffung kümmern. Benutzen Sie einfach bereits vorhandene Geräte - <b>völlig ohne Installation.</b></p>
                        </div>
                    </div>
                </div>
            </CallToAction>
            <USPS>
                <div className="container">
                    <h2>Unsere Prinzipien</h2>
                    <h3>Dafür steht das Team hinter scanmetrix.</h3>
                    <div className="usps">
                        <div className="usp">
                            <i className="fas fa-browser" />
                            <p className="title">Wir <i className="far fa-heart" /> Kompatibilität</p>
                            <p className="description">
                                Der scanmetrix Innendienst ist mit jedem modernen Webbrowser kompatibel (Google Chrome, Microsoft Edge, Mozilla Firefox etc.). Der Außendienst (scanmetrix Mission) wird als geräteunbhängige, offlinefähige PWA angeboten. Updates geschehen völlig automatisch im Hintergrund.
                            </p>
                        </div>
                        <div className="usp">
                            <i className="fas fa-blinds" />
                            <p className="title">Wir <i className="far fa-heart" /> Datenschutz</p>
                            <p className="description">
                                Datenschutz wird bei uns <b>ganz groß</b> geschrieben. Alle unsere Produkte sind 100% DSGVO-konform und halten sich an alle maßgeblichen Datenschutznormen. Die dabei verwendeten Technologien sind State-of-the-art, um das bestmögliche Qualitätsniveau unserer Datensicherungssysteme zu gewährleisten.
                            </p>
                        </div>
                        <div className="usp">
                            <i className="fas fa-code" />
                            <p className="title">Wir <i className="far fa-heart" /> Entwickler</p>
                            <p className="description">
                                Sie möchten scanmetrix an Ihre bestehenden Systeme anbinden oder sind selbst Softwareanbieter, der eine Schnittstelle zu uns anbieten möchte? Kein Problem! scanmetrix stellt eine öffentliche REST-API bereit, mit welcher alle Funktionen unseres Produkts angesteuert und ausgelesen werden können.
                            </p>
                        </div>
                    </div>
                </div>
            </USPS>

            <NewsArticle>
                <div className="container">
                    <div className="inner">
                        <div className="left">
                            <h3>IT am Scheideweg</h3>
                            <h4>Ein Wort von unserem Geschäftsführer</h4>
                            <p>Die IT-Landschaften des Mittelstands wandeln sich derzeit grundlegend.<br /><b>Oder besser:</b> Sie müssen sich ändern, damit die Unternehmen flexibel, kundenorientiert und wettbewerbsfähig bleiben. Die Zukunft gehört den „Microservices“. Ein Weckruf.</p>
                            <button onClick={() => window.open("https://www.themenschmiede.com/it-am-scheideweg", "_blank")}><i className="far fa-arrow-right" /> Weiterlesen auf Themenschmiede.com</button>
                        </div>
                        <div className="right">
                            <img src="https://info.all-for-one.com/hs-fs/hubfs/Strategie%20Transformation/ALLFOYE/2021%20Themenschmiede%20Magazin/IT%20am%20Scheideweg_1867x865_Header.png?width=1900&height=600&length=1900&name=IT%20am%20Scheideweg_1867x865_Header.png" />
                            <p>Udo Witte, Geschäftsführer scanmetrix.fm GmbH</p>
                        </div>
                    </div>
                </div>
            </NewsArticle>
        <Pricing ref={ref => this.pricingRef = ref}>
            <div className="container">
                <div className="left">
                    <i className="fas fa-check-double" />
                    <h3>
                        Beginnen Sie noch <b>heute</b>, Ihr Facility Management zu digitalisieren.
                    </h3>
                    <h4>
                        scanmetrix führt Sie prozessbasiert durch die Datenerhebungsphase und stellt einen effizienten, sicheren und klar strukturierten Facility Management Betrieb sicher.
                    </h4>
                </div>
                <div className="right">
                    <div className="pricing onsite">
                        <p className="title">Admin</p>
                        {/*<div className="price">
                            <p className="currency"><i className="fas fa-euro-sign" /></p>
                            <p className="amount">299</p>
                            <p className="type">pro Monat</p>
                        </div>*/}
                        <p className="description">Pro Person, die viele/alle Liegenschaften administriert, delegiert und steuert</p>
                        <ul>
                            <li><i className="fas fa-check" /> Alles von Operator</li>
                            <li><i className="fas fa-check" /> Ganzheitlicher Überblick</li>
                            <li><i className="fas fa-check" /> Unternehmensadministration</li>
                            <li><i className="fas fa-check" /> BI-Anbindung und Auswertung</li>
                        </ul>
                        <button onClick={() => this.contactRef.scrollIntoView({ behaviour: "smooth", block: "start" })}>Kontakt aufbauen</button>
                    </div>
                    <div className="pricing office">
                        <p className="title">Operator</p>
                        {/*<div className="price">
                            <p className="currency">€</p>
                            <p className="amount">99</p>
                            <p className="type">pro Monat</p>
                        </div>*/}
                        <p className="description">Pro Person, die mindestens eine Liegenschaft verwaltet und pflegt</p>
                        <ul>
                            <li><i className="fas fa-check" /> Facility Management</li>
                            <li><i className="fas fa-check" /> Progressive Datenerhebung</li>
                            <li><i className="fas fa-check" /> Dokumentenwesen</li>
                            <li><i className="fas fa-check" /> Operativer Betrieb</li>
                        </ul>
                        <button onClick={() => this.contactRef.scrollIntoView({ behaviour: "smooth", block: "start" })}>Kontakt aufbauen</button>
                    </div>
                    {/*<p className="bottomText">zzgl. 399€ pro Monat Grundgebühr</p>*/}
                </div>
            </div>
        </Pricing>
            <div style={{ background: "#20242b" }}>
                <FAQ>
                    <div className="container">
                        <h2>FAQ - Häufige Fragen</h2>
                        <h3>Sie können Ihre Frage nicht finden? Kontaktieren Sie uns gern!</h3>
                        <FAQItem title="Wie erhalte ich Zugriff auf scanmetrix?">
                            Sie erhalten scanmetrix im Rahmen eines sogenannten <b>Onboarding-Prozesses</b>. Folgende Schritte kommen auf Sie zu:
                            <ul style={{ marginTop: 16, listStyleType: "decimal" }}>
                                <li>Sie bauen Kontakt zu uns über das Kontaktformular oder telefonisch auf.</li>
                                <li>Wir melden uns umgehend bei Ihnen, um einen Präsentations- und Kennenlerntermin zu vereinbaren.</li>
                                <li>Im Anschluss des Termins erhalten Sie eine völlig kostenfreie Demoversion, die Sie 30 Tage lang auf Herz und Nieren testen können. In diesem Zeitraum betreuen wir Sie in der Handhabung der Software.</li>
                                <li>Zum Ende der Demoversion, oder durch vorzeitige Beendigung durch Sie, setzen wir uns mit Ihnen in Verbindung und erstellen Ihnen ein auf Ihre Unternehmensgröße und Schnittstellen angepasstes Angebot (Preise wie oben beschrieben).</li>
                                <li>Sagt Ihnen unser Produkt zu, klären wir umgehend den Papierkram und vereinbaren einen gemeinsamen Onboarding- oder Schulungstermin.</li>
                                <li>Sie können durchstarten <i className="far fa-rocket-launch" /></li>
                            </ul>
                        </FAQItem>
                        <FAQItem title="Welchen Mehrwert bietet scanmetrix gegenüber anderen CAFM Portalen?">
                            <ul>
                                <li>Das scanmetrix CAFM ist Bestandteil einer großen Kollaborationsplattform, welche Gebäudebetreiber, FM-Dienstleister, Handwerker und Subunternehmer digital zusammen bringt und so diverse Möglichkeiten des Outsourcing ermöglicht</li>
                                <li>Bei scanmetrix handelt es sich um ein sehr neues Produkt, weshalb nur State-of-the-art Technologien eingesetzt werden</li>
                                <li>Sie erhalten eine private Cloudinstanz, die wir für Sie managen und betreiben - völlig unabhängig von Ihrer Infrastruktur</li>
                                <li>Die Software kann geräteunabhängig verwendet werden</li>
                                <li>Die Software verfügt über eine sehr einfache Benutzeroberfläche, mit der Sie sich von Tag eins zurechtfinden</li>
                                <li>Die Software bietet eine REST-API sowie diverse Schnittstellen zu gängigen Softwarelösungen und ermöglicht damit eine nahtlose Integration in Ihre IT</li>
                                <li>Wir sind ein junges, dynamisches Team, das mit den Anforderungen der Zeit mitwächst und daher eine große Affinität für Feedback, Funktionswünsche und Prozessoptimierungen seitens des Kunden hegt</li>
                            </ul>
                        </FAQItem>
                        <FAQItem title="Für welche Unternehmensgrößen ist scanmetrix geeignet?">
                            scanmetrix ist für den Einsatz im Mittelstand bis Konzernstruktur konzipiert. Egal ob sie fünf oder 2000 Liegenschaften betreiben - unsere Cloud skaliert automatisch mit Ihren Bedürfnissen. Gerne besprechen wir individuelle Anpassungen an Ihre Unternehmensstruktur (wie z.B. Workflowimplementierung, FI-Schnittstellen, BI-Anbindung oder Schulungskonzepte) in einem persönlichen Gespräch. Auf Grund der vielfältigen Natur unserer Kunden kennen wir die Strukturen von Filialisten, Hotellerie, Industrie und Logistik besonders gut - und können diese häufig ohne weiteres Zutun digital abbilden.
                        </FAQItem>
                        <FAQItem title="Kann ich meine bestehenden Daten in scanmetrix importieren?">
                            Grundsätzlich ist es möglich, Daten jeder Art zu importieren. Dafür benötigen wir vorab von Ihnen den Aufbau Ihrer bestehenden Datenstruktur (z.B. als CSV, Excel, Schnittstelle oder bestehendes CAFM) um die Details mit Ihnen zu klären. Darüberhinaus bietet scanmetrix von Haus aus diverse Schnittstellen zu gängigen Dateiformaten, um bspw. den Import Ihrer Liegenschaften zu erleichtern - ganz ohne unser Zutun. Genügt diese Herangehensweise nicht, stellt Ihnen unser Partner, die <b>SymProject GmbH</b>, gerne individuelle Entwicklungsressourcen zur Verfügung, um eine maßgeschneiderte Lösung zu finden.
                        </FAQItem>
                        <FAQItem title="Für wen ist scanmetrix geeignet?">
                            scanmetrix richtet sich hauptsächlich an mittelständische bis Konzern-große Unternehmen (sowie derer FM-Dienstleister), die folgende Voraussetzungen erfüllen:
                            <ul>
                                <li>Sie verwalten Ihr technisches Facility Management an einer oder mehreren Liegenschaften</li>
                                <li>Sie beschäftigen diverse Dienstleister damit, Ihre prüfpflichtigen TGA instandzuhalten</li>
                                <li>Sie haben mindestens einen Facility Manager oder Sachkundigen, der das CAFM bedienen wird</li>
                                <li>Ihre Unternehmens- und Infrastruktur ermöglicht den Einsatz von (Private-)Cloud-Lösungen</li>
                            </ul>
                        </FAQItem>
                        <FAQItem title="Woher erhalte ich die erwähnten QR-Code Sticker für die Objektaufnahme?">
                            Die QR-Code Sticker für die Objektaufnahme sind optional. Jedoch raten wir Ihnen dazu, diese einzusetzen - das erleichtert nicht nur Ihnen die Zuordnung der Objekte, sondern auch Ihren Dienstleistern, wenn diese bei Ihnen Wartungen oder Instandhaltungen durchführen. Die QR-Code Sticker werden bei uns im Haus hergestellt und sind käuflich erwerbbar. Alle Details dazu klären wir selbstverständlich im Rahmen Ihres Onboardings.
                        </FAQItem>
                    </div>
                </FAQ>
            </div>
            <Contact ref={ref => this.contactRef = ref}>
                <div className="container">
                    <h2>Kontaktieren Sie uns</h2>
                    <h3>Vereinbaren Sie einen Präsentationstermin oder ein kurzes Webinar, um scanmetrix näher kennenzulernen.</h3>
                    <div className="content">
                        <div className="left">
                            <div className="inputs">
                                <Input label="Ihr Name" value={this.state.name} onChange={name => this.setState({ name })} required />
                                <Input label="Telefonnr." value={this.state.phone} onChange={phone => this.setState({ phone })} />
                                <Input label="E-Mail-Adresse" value={this.state.email} onChange={email => this.setState({ email })} required />
                                <Input label="Firma" value={this.state.company} onChange={company => this.setState({ company })} />
                                <div className="text">
                                    <Input label="Ihre Nachricht an uns" textArea value={this.state.message} required onChange={message => this.setState({ message })} />
                                </div>
                            </div>
                            <div className="privacy">
                                <Checkbox checked={this.state.privacyChecked} toggle={() => this.setState({ privacyChecked: !this.state.privacyChecked })} label={<>Ich habe den <a href="https://scanmetrix.fm/privacy-policy" target="_blank">Datenschutzhinweis</a> der scanmetrix.fm GmbH gelesen und stimme der Weiterverarbeitung meiner Daten für diese Kontaktaufnahme zu.</>} />
                            </div>
                            <button onClick={() => {
                                if(this.state.privacyChecked) {
                                    let errors = []

                                    if(!this.state.name || (this.state.name && this.state.name.trim().length === 0)) errors.push("name")
                                    if(!this.state.email || (this.state.email && this.state.email.trim().length === 0)) errors.push("email")
                                    if(!this.state.message || (this.state.message && this.state.message.trim().length === 0)) errors.push("message")

                                    if(errors.length === 0) {
                                        if(this.state.email.toLowerCase()
                                            .match(
                                                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                            )) {

                                            Swal.fire({
                                                title: "Kontaktanfrage erfolgreich!",
                                                html: "Ihre Kontaktanfrage wurde erfolgreich an uns übermittelt. Sie erhalten in Kürze eine Bestätigungsmail.<br /><br />Wir werden uns schnellstmöglich mit Ihnen in Verbindung setzen.",
                                                icon: "success",
                                                didOpen: () => {
                                                    Swal.showLoading()
                                                },
                                                confirmButtonText: "Verstanden"
                                            })

                                            emailjs.send("service_0kxwk21", "template_aw8z6mj", {
                                                name: this.state.name,
                                                phone: this.state.phone,
                                                company: this.state.company,
                                                email: this.state.email,
                                                message: this.state.message
                                            }, "user_x8940LKO2DVMwnbhkeQXQ").then(data => {
                                                Swal.hideLoading()

                                                if(data.status === 200) {
                                                    this.setState({ name: null, phone: null, email: null, company: null, message: null, privacyChecked: false })
                                                } else {
                                                    Swal.fire({
                                                        title: "Fehlgeschlagen.",
                                                        text: "Beim Versenden der Nachricht ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es später erneut oder nutzen Sie eine unserer anderen Kontaktmöglichkeiten.",
                                                        icon: "warning",
                                                        confirmButtonText: "Verstanden"
                                                    })
                                                }
                                            })
                                        } else {
                                            Swal.fire({
                                                title: "Fehlgeschlagen.",
                                                text: "Bitte überprüfen Sie Ihre E-Mail-Adresse auf Richtigkeit.",
                                                icon: "warning",
                                                confirmButtonText: "Verstanden"
                                            })
                                        }
                                    } else {
                                        Swal.fire({
                                            title: "Fehlgeschlagen.",
                                            html: "Bitte überprüfen Sie Ihre Eingaben und stellen Sie sicher, dass " + (errors.length > 1 ? "folgende Felder ausgefüllt sind" : "folgendes Feld ausgefüllt ist") + ":<br/><br/><ul>" + errors.map(error => ("<li>" + ({
                                                name: "Ihr Name",
                                                email: "E-Mail-Adresse",
                                                message: "Ihre Nachricht an uns"
                                            })[error] + "</li>")).join("") + "</ul>",
                                            icon: "warning",
                                            confirmButtonText: "Verstanden"
                                        })
                                    }
                                } else {
                                    Swal.fire({
                                        title: "Fehlgeschlagen.",
                                        text: "Bitte akzeptieren Sie den Datenschutzhinweis, bevor Sie fortfahren.",
                                        icon: "warning",
                                        confirmButtonText: "Verstanden"
                                    })
                                }
                            }}><i className="far fa-paper-plane" /> Kontaktanfrage senden</button>
                        </div>
                        <div className="right">
                            <i className="fas fa-projector symbol" />
                            <h4>Sie benötigen eine Präsentation?</h4>
                            <p className="text">Ihnen gefällt, was wir tun, jedoch müssen Sie Ihr Team noch überzeugen? Kein Problem! Laden Sie einfach unsere Präsentation in PDF-Form herunter.</p>
                            <div className="download" onClick={() => window.open("/Flyer%20Betreiber.pdf", "_blank")}><p><i className="fas fa-download" /> Software Flyer.pdf (1,25 MB)</p></div>
                            <div className="download" onClick={() => window.open("/Implementierungsleitfaden.pdf", "_blank")}><p><i className="fas fa-download" /> Implementierungsleitfaden.pdf (1,49 MB)</p></div>
                        </div>
                    </div>
                </div>
                <div className="background">
                    <div className="circleOuter">
                        <div className="circleInner">
                            <div className="planet" />
                        </div>
                    </div>
                </div>
            </Contact>
            <div style={{ background: "white" }}>
                <Footer>
                    <div className="container">
                        <div className="column">
                            <img className="logo" src="/logo_text_white.svg" alt="Unser Logo auf dunklem Hintergrund" />
                            <p className="description">Die scanmetrix.fm GmbH aus Mülheim an der Ruhr ist ein junges PropTech-Startup im Bereich der technischen Immobiliendigitalisierung. Mit ihrer gleichnamigen Software versucht sie, den Unternehmensalltag von Handwerkern verschiedenster Gewerke zu digitalisieren und ermöglicht damit den Gebäudebetreibern, ausgeführte Arbeiten und anstehende Prüfungen über ein CAFM-Portal transparent zu verfolgen und zu steuern.</p>
                        </div>
                        <div className="column">
                            <p className="title">Soziale Medien</p>
                            <ul>
                                <li>
                                    <a href="https://www.facebook.com/scanmetrix.fm/">Facebook <i className="fab fa-facebook" /></a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/scanmetrixfm">Instagram <i className="fab fa-instagram" /></a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/company/scanmetrix-fm-gmbh/">LinkedIn <i className="fab fa-linkedin" /></a>
                                </li>
                            </ul>
                        </div>
                        <div className="column">
                            <p className="title">Schnellverweise</p>
                            <ul>
                                <li>
                                    <a href="https://handwerk.scanmetrix.io">Für Handwerker</a>
                                </li>
                                <li>
                                    <a href="https://help.cp.scanmetrix.io">Hilfebereich</a>
                                </li>
                                <li>
                                    <a href="https://status.scanmetrix.io">Status & Störungen</a>
                                </li>
                                <li>
                                    <a href="https://scanmetrix.fm/privacy-policy">Datenschutz</a>
                                </li>
                                <li>
                                    <a href="https://scanmetrix.fm/imprint">Impressum</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="copyright">
                        <div className="left">
                            Made with <i className="fas fa-heart" /> & hosted in Germany
                        </div>
                        <div className="right">
                            Alle angegebenen Preise verstehen sich zzgl. 19% Mehrwertsteuer.
                        </div>
                    </div>
                </Footer>
            </div>
        </>
    }
}

const ESG = styled.div`
  padding-bottom: 128px;
  .container {
    width: 100%;
    padding: 0 64px;
    margin: 0 auto;
    max-width: 1280px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 0 64px;
    
    h2 {
      font-size: 48px;
      font-weight: 900;
      background-color: #3b97d3;
      background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255), rgb(220 135 255), rgb(220 135 255));
      background-size: 100%;
      background-repeat: repeat;
      -webkit-background-clip: text;
      user-select: none;
      -webkit-text-fill-color: transparent;
    }

    h3 {
      margin-bottom: 64px;
      font-size: 24px;
      font-weight: 300;
      opacity: 0.75;
      user-select: none;
      margin-top: 8px;
    }
    
    h2, h3 {
        grid-column-start: 1;
        grid-column-end: 4;
    }

    .column {
        h4 {
          font-size: 22px;
            font-weight: 300;
            margin-bottom: 24px;
        }
        
        ul {
            li {
                width: 100%;
                display: flex;
                list-style-type: none;
                align-items: center;
                margin-bottom: 40px;
                font-size: 16px;
              
                &:last-child {
                    margin-bottom: 0;
                }
              
                i {
                  flex-shrink: 0;
                  width: 64px;
                  height: 64px;
                  border-radius: 100%;
                  margin-right: 16px;
                  background: rgb(46 204 113 / 26%);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #2ecc71;
                  font-size: 24px;
                }
            }
        }
      
        &:nth-child(4) {
            ul {
                li {
                    i {
                        color: #e74c3c;
                        background: rgb(231 76 60 / 25%);
                    }
                }
            }
        }

      &:nth-child(5) {
        ul {
          li {
            i {
              color: #34495e;
              background: rgb(52 73 94 / 25%);
            }
          }
        }
      }
    }
    
    @media screen and (max-width: 1400px) {
      box-sizing: border-box;
      grid-template-columns: 1fr;
      
      h2, h3 {
          grid-column-end: 2 !important;
      }
      
      .column {
          margin-bottom: 48px;
        
          li {
              margin-bottom: 24px !important;
          }
        
          &:last-child {
              margin-bottom: 0;
          }
      }
    }
  }
`

const USPS = styled.div`
    .container {
          width: 100%;
          padding: 0 64px;
          margin: 0 auto;
          max-width: 1280px;

      @media screen and (max-width: 1400px) {
          box-sizing: border-box;
      }

      h2 {
        font-size: 48px;
        font-weight: 900;
        user-select: none;
        color: #20242b;
      }

      h3 {
        margin-bottom: 64px;
        font-size: 24px;
        font-weight: 300;
        opacity: 0.75;
        user-select: none;
        margin-top: 8px;
      }

        .usps {
          width: 100%;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          grid-gap: 64px;

          @media screen and (max-width: 1400px) {
              grid-template-columns: 1fr;
          }

          .usp {
            i.fas:first-child {
              font-size: 64px;
              margin-bottom: 32px;
              background-color: #3b97d3;
              background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255));
              background-size: 100%;
              background-repeat: repeat;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }

            i.fa-heart {
              color: #e74c3c;
            }

            .title {
              margin-bottom: 16px;
              font-size: 24px;
              font-weight: 600;
            }

            .description {
              font-weight: 300;
              font-size: 18px;
              line-height: 32px;
            }
          }
        }
    }

    padding-bottom: 128px;
`

const Cooperations = styled.div`
  padding-bottom: 128px;
  background: white;
  padding-top: 128px;
  
  .logos {
      width: 100%;
      flex-wrap: nowrap;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
    
      @media screen and (max-width: 1400px) {
          display: grid;
          grid-gap: 48px;
          grid-template-columns: 1fr 1fr 1fr;
      }

    @media screen and (max-width: 1024px) {
      display: grid;
      grid-gap: 48px;
      grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px) {
      display: grid;
      grid-gap: 48px;
      grid-template-columns: 1fr;
    }
    
    img {
        max-height: 48px;
        height: 100%;
        filter: grayscale(100%) brightness(0) opacity(0.35);
        transition: all 0.3s;
    }
    
      a {
          display: block;
          height: 48px;
        
          &:hover {
              img {
                  filter: none;
              }
          }
      }
  }
  
  .container {
    
    width: 100%;
    padding: 0 64px;
    margin: 0 auto;
    max-width: 1280px;

    @media screen and (max-width: 1400px) {
      box-sizing: border-box;
    }

    h2 {
      font-size: 48px;
      font-weight: 900;
      background-color: #3b97d3;
      background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255), rgb(220 135 255));
      background-size: 100%;
      background-repeat: repeat;
      -webkit-background-clip: text;
      user-select: none;
      -webkit-text-fill-color: transparent;
    }

    h3 {
      margin-bottom: 64px;
      font-size: 24px;
      font-weight: 300;
      opacity: 0.75;
      user-select: none;
      margin-top: 8px;
    }
  }
`

const StyledCheckbox = styled.div`
    display: flex;

    .checkbox {
      width: 24px;
      height: 24px;
      border: 1px solid rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      flex-shrink: 0;
      margin-right: 16px;
      display: flex;
        align-items: center;
      justify-content: center;
      color: #3b97d3;
      cursor: pointer;
    }

    label {
      font-weight: 400;
      color: rgba(0, 0, 0, 0.75);
      user-select: none;

      a {
          color: #3b97d3;
          text-decoration: none;
      }
    }
`

class Checkbox extends Component {
    render() {
        return <StyledCheckbox onClick={this.props.toggle}>
            <div className="checkbox">
                {this.props.checked && <i className="fas fa-check" />}
            </div>
            <label>{this.props.label}</label>
        </StyledCheckbox>
    }
}

const CallToAction = styled.div`
  margin-bottom: 128px;
  .container {
    width: 100%;
    padding: 0 64px;
    margin: 0 auto;
    max-width: 1280px;
    height: 512px;
    background: white;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.1);
    position: relative;
    display: flex;

    @media screen and (max-width: 1400px) {
        box-sizing: border-box;
        margin: 32px;
        width: calc(100% - 64px);
        height: fit-content;
    }

    .background {
        position: absolute;
        z-index: 1;
        width: 30%;
        height: 100%;
        border-radius: 0 100% 100% 0;
        left: 0;
        top: 0;
        bottom: 0;
        background: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255));

        @media screen and (max-width: 1400px) {
            width: 100%;
            height: 200px;
            border-radius: 0 0 100% 100%;
        }
    }

    .content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 48px;
        z-index: 2;
        position: relative;
        user-select: none;

        @media screen and (max-width: 1400px) {
            grid-template-columns: 1fr;
            padding-bottom: 96px;
            grid-gap: 0;
        }

        .left {
            display: flex;
            height: 100%;
            align-items: center;

            img {
                height: 60%;
                margin-left: 64px;
                margin-top: 32px;
                -webkit-user-drag: none;
                max-width: 100%;

                @media screen and (max-width: 1400px) {
                    margin: 0 auto !important;
                    height: auto;
                    width: 420px;
                    margin-top: 96px !important;
                    margin-bottom: 48px !important;
                }
            }
        }

        .right {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            box-sizing: border-box;
            padding-right: 64px;

            @media screen and (max-width: 1400px) {
                text-align: center;
                padding-right: 0;
            }

            h3 {
                font-size: 40px;
                font-weight: 900;
            }

            p {
                margin-top: 16px;
                font-size: 22px;
                line-height: 36px;
                font-weight: 300;

                b {
                    color: rgb(220 135 255);
                }
            }
        }
    }
  }
`

const Footer = styled.footer`
  background: #20242b;
  padding: 128px 0;
  color: white;
  border-radius: 96px 0 0 0;

  .copyright {
    width: 100%;
    padding: 0 64px;
    max-width: 1280px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 32px auto 0;
    font-size: 14px;

    @media screen and (max-width: 1400px) {
      box-sizing: border-box;
    }

    @media screen and (max-width: 850px) {
        flex-wrap: wrap;
        justify-content: flex-start;

        .left, .right {
            flex-shrink: 0;
            width: 100%;
        }
    }

    .left {
        opacity: 0.75;
    }

    .right {
        opacity: 0.3;
    }

    i {
      color: #e74c3c;
    }
  }

  .container {
    width: 100%;
    padding: 0 64px;
    margin: 0 auto;
    max-width: 1280px;
    display: grid;
    grid-template-columns: 1.75fr 1fr 1fr;
    grid-gap: 64px;

    @media screen and (max-width: 1400px) {
        box-sizing: border-box;
    }

    @media screen and (max-width: 1080px) {
        grid-template-columns: 1fr 1fr;

        .column:first-child {
            grid-column-start: 1;
            grid-column-end: 3;

            img {
                width: 30%;
            }
        }

        .column * {
            text-align: left !important;

            i {
                margin-left: 10px;
            }
        }

        .column {
            align-items: flex-start !important;
        }
    }

    @media screen and (max-width: 800px) {
        img {
            width: 250px !important;
        }
    }

    @media screen and (max-width: 600px) {
        grid-template-columns: 1fr;

        .column:first-child {
            grid-column-end: 2;
        }
    }

    .column {
      text-align: right;

      &:first-child {
        text-align: left;
      }

      &:nth-child(2), &:nth-child(3) {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
      }

      img {
        width: 65%;
        margin-bottom: 16px;
      }

      ul {
        text-align: right;

        li {
          list-style-type: none;
          height: 40px;
          display: flex;
          align-items: center;
          text-align: right;
          font-size: 18px;

          a, p {
            width: 100%;
            text-align: right;
            opacity: 0.75;
            font-weight: 300;
            user-select: none;
            cursor: pointer;
            transition: all 0.3s;
            color: white;
            text-decoration: none;

            i {
              width: 32px;
              text-align: right;
            }

            &:hover {
              opacity: 1;
            }
          }
        }
      }

      p.description {
        font-size: 16px;
        line-height: 28px;
        font-weight: 300;
        opacity: 0.75;
      }

      .title {
        font-size: 24px;
        margin-bottom: 16px;
        font-weight: 900;
        background-color: #3b97d3;
        background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255));
        background-size: 100%;rgb(59 151 211 / 11%)
        background-repeat: repeat;
        -webkit-background-clip: text;
        user-select: none;
        -webkit-text-fill-color: transparent;
        width: fit-content;
      }
    }
  }
`

const Contact = styled.div`
    background: white;
    width: 100%;
    padding: 128px 0;
    position: relative;
    overflow: hidden;
  border-radius: 96px 0 0 0;

    .privacy {
        margin-top: 16px;
    }

    .left .inputs {
        display: grid;
        grid-gap: 32px;
        grid-template-columns: 1fr 1fr;

        .text {
            grid-column-start: 1;
            grid-column-end: 3;
        }

        @media screen and (max-width: 600px) {
            grid-template-columns: 1fr;

            .text {
                grid-column-end: 2;
            }
        }
    }

    .content {
        display: grid;
        grid-template-columns: 1fr 0.7fr;
        grid-gap: 80px;
        z-index: 2;
        position: relative;

        @media screen and (max-width: 980px) {
            grid-template-columns: 1fr;
        }

        .right {
            h4 {
                font-size: 28px;
                font-weight: 400;
            }

            p.text {
                font-weight: 300;
                line-height: 32px;
                margin-top: 16px;
                font-size: 18px;
            }

            i.symbol {
              font-size: 90px;
              margin-bottom: 32px;
              background-color: #3b97d3;
              background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255));
              background-size: 100%;
              background-repeat: repeat;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }

            .download {
                color: #3b97d3;
                margin-top: 16px;
                font-size: 18px;
                user-select: none;
                cursor: pointer;
                transition: opacity 0.3s;
                display: flex;
                align-items: center;

                b {
                    margin-left: 8px;
                }

                &:hover {
                    opacity: 0.75;
                }

                i {
                    margin-right: 8px;
                }
            }
        }
    }

  button {
    background: #3b97d3;
    color: white;
    outline: 0;
    border: none;
    height: 48px;
    padding: 0 24px;
    border-radius: 5px;
    font-size: 18px;
    display: flex;
    align-items: center;
    user-select: none;
    cursor: pointer;
    transition: all 0.3s;
    margin-top: 24px;

    i {
        margin-right: 10px;
    }

    &:hover {
      background: rgb(220 135 255);
    }
  }

  h2 {
    font-size: 48px;
    font-weight: 900;
    user-select: none;
    color: #20242b;
  }

  h3 {
    margin-bottom: 64px;
    font-size: 24px;
    font-weight: 300;
    opacity: 0.75;
    user-select: none;
    margin-top: 8px;
    width: 50%;

    @media screen and (max-width: 980px) {
      width: 100%;
    }
  }

    .background {
        position: absolute;
        z-index: 1;
        width: 1024px;
        height: 1024px;
        right: 0;
        top: 0;
        transform: translate(50%, -50%);

        .circleOuter {
            width: 100%;
            height: 100%;
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .circleInner {
            width: 70%;
            height: 70%;
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

      .planet {
        width: 70%;
        height: 70%;
        background: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255));
        border-radius: 100%;
      }
    }

  .container {
    width: 100%;
    padding: 0 64px;
    z-index: 2;
    margin: 0 auto;
    max-width: 1280px;
    position: relative;

    @media screen and (max-width: 1400px) {
        box-sizing: border-box;
    }
  }
`

/*
const currentFrame = index => (
    `/animation/ezgif-frame-${index.toString().padStart(3, '0')}.png`
)

class DeviceWrapper extends Component {
    state = { index: 1, images: [] }

    constructor(props) {
        super(props)

        this.handleScroll = this.handleScroll.bind(this)

        this.handleScroll(true)
    }

    handleScroll(isConstructor) {
        const frames = 41
        const speed = 600
        const offset = 900
        const index = Math.max(1, Math.min(Math.round((Math.max(window.pageYOffset - offset, 0) / speed) * frames), frames))

        if(isConstructor === true) this.state.index = index
        else this.setState({ index })
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll)

        let images = []

        for(let i = 0; i < 41; i++) {
            const img = new Image()
            img.src = currentFrame(i + 1)

            images.push(img)
        }

        this.setState({ images })
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    render() {
        return <video
            width="1280"
            muted
            preload="auto"
            playsInline
            autoPlay={false}
            ref={ref => this.videoRef = ref}
        >
            <source type="video/mp4" src="/animation/new.mp4" />
        </video>
        if(!this.state.images.length) return null
        return <DeviceAnimation img={this.state.images[this.state.index - 1]} />
    }
}

const DeviceAnimation = props => {
    const canvasRef = useRef(null)

    useEffect(() => {
        const canvas = canvasRef.current
        canvas.width = 1550
        canvas.height = 1080
        const context = canvas.getContext("2d")
        context.drawImage(props.img, 0, 0, 1550, 1080)
    }, [ props.img ])

    return <canvas ref={canvasRef} />
}*/

const ModalBackground = styled.div`
    z-index: 1000;
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.25);
`

const ModalContainer = styled.div`
    padding: 64px;
    background: white;
    border-radius: 15px;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 64px;
    max-width: 1024px;
    margin: 32px;

  img {
    width: 100%;
    max-height: 100%;
    object-fit: contain;
    -webkit-user-drag: none;
    margin: auto 0;
  }

    @media screen and (max-width: 1080px) {
        grid-template-columns: 1fr;
        max-height: calc(100vh - 200px);
        overflow-y: auto;
        overflow-x: hidden;

        img {
            max-height: 250px;
        }
    }

    .right {
        display: flex;
        flex-direction: column;

        .title {
            font-size: 40px;
            font-weight: 900;
            margin-bottom: 16px;
          background-color: #3b97d3;
          background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255));
          background-size: 100%;
          background-repeat: repeat;
          -webkit-background-clip: text;
          user-select: none;
          -webkit-text-fill-color: transparent;
        }

        .subtitle {
            margin-bottom: 24px;
            line-height: 32px;
            font-size: 18px;
        }

        .features {
          padding: 24px;
          border-radius: 5px;
          background: rgb(59 151 211 / 11%);

          .featuresTitle {
              font-size: 18px;
              font-weight: 600;
              color: #3b97d3;

              i {
                  margin-right: 8px;
              }
          }

          ul {
              margin-top: 8px;
          }

          li {
              margin-left: 24px;
              line-height: 30px;
          }
        }
    }
`

class FeatureModal extends Component {
    state = { open: false }

    constructor(props) {
        super(props)

        this.open = this.open.bind(this)
    }

    open() {
        if(!this.props.disabled) this.setState({ open: true })
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    render() {
        if(!this.state.open) return null

        return <ModalBackground onClick={() => this.setState({ open: false })}>
            <ModalContainer onClick={event => event.stopPropagation()}>
                <img src={this.props.img} />
                <div className="right">
                    <p className="title">{this.props.title}</p>
                    <p className="subtitle">{this.props.subtitle}</p>
                    <div className="features">
                        <p className="featuresTitle"><i className="far fa-rocket-launch" /> Diese Funktionen erwarten Sie:</p>
                        <ul>
                            {this.props.features.map((feature, index) => <li key={index}>{feature}</li>)}
                        </ul>
                    </div>
                </div>
            </ModalContainer>
        </ModalBackground>
    }
}

class FAQItem extends Component {
    state = { open: false }

    render() {
        return <StyledFAQItem>
            <div className="title" onClick={() => this.setState({ open: !this.state.open })}><i className={`far fa-${this.state.open ? "minus" : "plus"}`} /> {this.props.title}</div>
            <div className={`content ${this.state.open ? "open" : ""}`}>{this.props.children}</div>
        </StyledFAQItem>
    }
}

const StyledFAQItem = styled.div`
    margin-bottom: 24px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 24px;

    &:last-child {
        margin-bottom: 0;
        border-bottom: none;
    }

    .title {
        font-size: 24px;
        user-select: none;
        cursor: pointer;
        font-weight: 300;
        display: flex;
        align-items: center;

        i {
            color: #3b97d3;
            width: 40px;
            flex-shrink: 0;
        }
    }

    .content {
        font-size: 18px;
        line-height: 36px;
        max-height: 0;
        overflow: hidden;
        transition: all 0.3s;
        box-sizing: border-box;
        opacity: 0;
        font-weight: 300;
        padding-left: 40px;

        &.open {
            max-height: 350px;
            padding-top: 16px;
            opacity: 1;

            @media screen and (max-width: 1400px) {
                max-height: 1024px;
            }
        }
    }
`

const FAQ = styled.div`
    padding: 128px 0;
  background: #F8F8F8;
  border-radius: 96px 0 0 0;

    h2 {
        font-size: 48px;
        font-weight: 900;
        background-color: #3b97d3;
        background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255), rgb(220 135 255));
        background-size: 100%;
        background-repeat: repeat;
        -webkit-background-clip: text;
        user-select: none;
        -webkit-text-fill-color: transparent;
    }

    h3 {
        margin-bottom: 64px;
        font-size: 24px;
        font-weight: 300;
        opacity: 0.75;
        user-select: none;
        margin-top: 8px;
    }

  .container {
    width: 100%;
    padding: 0 64px;
    margin: 0 auto;
    max-width: 1280px;

    @media screen and (max-width: 1400px) {
        box-sizing: border-box;
    }

    b, i {
      color: #3b97d3;
    }

      ul {
        li {
          padding-left: 12px;
          margin-left: 20px;
        }
      }
  }
`

const Features = styled.div`
  padding: 192px 0 128px 0;
  border-radius: 0 0 96px 0;

  .container {
    width: 100%;
    padding: 0 64px;
    margin: 0 auto;
    max-width: 1280px;

    @media screen and (max-width: 1400px) {
        box-sizing: border-box;
    }
  }

  h2 {
    font-size: 48px;
    font-weight: 900;
    background-color: #3b97d3;
    background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255));
    background-size: 100%;
    background-repeat: repeat;
    -webkit-background-clip: text;
    user-select: none;
    -webkit-text-fill-color: transparent;
  }

  h3 {
    margin-bottom: 64px;
    font-size: 24px;
    font-weight: 300;
    opacity: 0.75;
    user-select: none;
    margin-top: 8px;
  }

  h2, h3 {
      text-align: center;
  }

  button {
    background: #3b97d3;
    color: white;
    outline: 0;
    border: none;
    height: 48px;
    padding: 0 24px;
    border-radius: 5px;
    font-size: 18px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    user-select: none;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: rgb(220 135 255);
    }
  }

  .features {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 80px 48px;
      margin: 80px 0;

      @media screen and (max-width: 1300px) {
          grid-template-columns: 1fr 1fr;
      }

      @media screen and (max-width: 850px) {
          grid-template-columns: 1fr;
      }

      .feature {
          display: flex;
          align-items: center;

          .right {
              i {
                  color: rgba(0, 0, 0, 0.4);
              }
          }

          .icon {
              flex-shrink: 0;
              width: 90px;
              height: 90px;
              display: flex;
              background: white;
              align-items: center;
              justify-content: center;
              color: #3b97d3;
              font-size: 42px;
              border-radius: 5px;
              box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.1);
              margin-right: 24px;
          }

          .title {
              font-size: 22px;
          }

          .subtitle {
              font-weight: 300;
              font-size: 15px;
              margin-top: 8px;
          }

          .learn {
              cursor: pointer;
              color: #3b97d3;
              margin-top: 8px;
              font-size: 16px;
              transition: color 0.3s;
              user-select: none;

                i {
                    color: inherit;
                    font-size: 14px;
                }

              &:hover {
                  color: rgb(220 135 255);
              }
          }
      }
  }
`

const StyledInput = styled.div`
    width: 100%;

    label {
        height: 16px;
        font-size: 20px;
        font-weight: 300;
        user-select: none;

        i {
            color: #3b97d3;
            margin-left: 4px;
            font-size: 10px;
            vertical-align: top;
            margin-top: 4px;
        }
    }

    input, textarea {
      font-size: 16px;
        font-family: inherit;
        width: 100%;
        height: 48px;
        margin-top: 8px;
        outline: 0;
        border: 1px solid rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        margin-bottom: 0;
        box-sizing: border-box;
        padding: 0 16px;
        font-weight: 300;
        transition: all 0.3s;

        &:focus {
            border-color: #3b97d3;
        }
    }

    textarea {
        height: 128px;
        resize: none;
        padding-top: 16px;
    }
`

class Input extends Component {
    render() {
        return <StyledInput>
            <label>{this.props.label}{this.props.required && <i className="fas fa-asterisk" />}</label>
            {!this.props.textArea && <input spellCheck="false" value={this.props.value || ""} onChange={e => this.props.onChange(e.target.value)} />}
            {this.props.textArea && <textarea spellCheck="false" value={this.props.value || ""} onChange={e => this.props.onChange(e.target.value)} />}
        </StyledInput>
    }
}

const Pricing = styled.div`
  background: #20242b;
  padding-top: 64px;
  padding-bottom: 96px;

  .container {
    width: 100%;
    padding: 0 64px;
    margin: 0 auto;
    max-width: 1280px;
    display: grid;
    grid-template-columns: 1fr 1.35fr;
    grid-gap: 80px;

    @media screen and (max-width: 1400px) {
        grid-template-columns: 1fr;
      box-sizing: border-box;
    }

    .left {
        color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;

        i {
            font-size: 90px;
            margin-bottom: 16px;
          background-color: #3b97d3;
          background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255));
          background-size: 100%;
          background-repeat: repeat;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        h3 {
            font-size: 44px;
            font-weight: 400;

            b {
                color: rgb(220 135 255);
            }
        }

        h4 {
            font-weight: 300;
            font-size: 24px;
            margin-top: 24px;
            opacity: 0.75;
            line-height: 48px;
        }
    }

    .bottomText {
        color: white;
        text-align: right;
        grid-column-start: 1;
        grid-column-end: 3;
        font-size: 14px;
        opacity: 0.5;
    }

    .right {
        display: grid;
        grid-template-columns: 1fr 1.1fr;
        grid-gap: 24px;
        margin-top: 96px;

        @media screen and (max-width: 1400px) {
            width: 60%;
            margin: 0 auto;
        }

        @media screen and (max-width: 1080px) {
            width: 80%;
        }

        @media screen and (max-width: 900px) {
            grid-template-columns: 1fr;
            width: 100%;

            .bottomText {
                grid-column-end: 2 !important;
            }
        }

        .pricing {
            background: white;
            padding: 32px;
            border-radius: 8px;
            height: min-content;
            margin: auto 0;
            .title {
              font-style: normal;
              font-weight: 900;
              background-color: #3b97d3;
              background-image: linear-gradient(45deg, rgb(59, 151, 211), rgb(220 135 255));
              background-size: 100%;
              background-repeat: repeat;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
                font-size: 32px;
                margin-bottom: 16px;
            }

            .price {
                font-size: 54px;
                font-weight: 900;
                display: flex;

                .amount {
                    color: #20242b;
                }

                .currency {
                    opacity: 0.5;
                    font-size: 24px;
                    margin-right: 8px;
                }

                .type {
                    font-size: 22px;
                    margin-left: 8px;
                    font-weight: 400;
                    opacity: 0.75;
                }
            }

            button {
                background: #3b97d3;
                color: white;
                outline: 0;
                border: none;
                height: 48px;
                padding: 0 24px;
                border-radius: 5px;
                font-size: 18px;
                display: flex;
                align-items: center;
                margin: 0 auto;
              user-select: none;
              cursor: pointer;
              transition: all 0.3s;

              &:hover {
                background: rgb(220 135 255);
              }
            }

            &.office {
                padding: 48px 48px;
            }

            &.onsite {
                button {
                    background: transparent;
                    border: 2px solid #3b97d3;
                    color: #3b97d3;

                    &:hover {
                        border-color: rgb(220 135 255);
                        color: rgb(220 135 255);
                    }
                }
            }

            .description {
                margin-top: 16px;
                line-height: 32px;
                font-size: 18px;
                opacity: 0.75;

                i {
                    opacity: 0.5;
                }
            }

            ul {
                margin: 32px 0;

                li {
                    list-style-type: none;
                    height: 40px;
                    line-height: 40px;
                    font-size: 16px;
                    color: rgba(0, 0, 0, 0.75);

                    i {
                        color: #3b97d3;
                        margin-right: 8px;
                    }
                }
            }
        }
    }
  }
`
const ModuleFacts = styled.div`
    width: 100%;
    background: #20242b;
    color: white;
    padding: 64px 0;

  .container {
    width: 100%;
    padding: 0 64px;
    margin: 0 auto;
    max-width: 1280px;

    @media screen and (max-width: 1400px) {
      box-sizing: border-box;
    }
  }
    
    .grid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-gap: 48px;
        
        @media screen and (max-width: 1024px) {
            grid-template-columns: 1fr 1fr;
        }

      @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
          grid-gap: 64px;
      }
      
        .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            
            .number {
                font-size: 48px;
            }
            
            .description {
                margin-top: 8px;
                opacity: 0.75;
                font-size: 20px;
            }
        }
    }
`

class Counter extends Component {
    state = { animated: false }

    render() {
        return <div className="item">
            <div className="number">
                <CountUp
                    start={0}
                    end={this.props.value}
                    duration={3}
                    decimals={0}
                    separator="."
                    suffix={this.props.suffix || "+"}
                >
                    {({ countUpRef, start }) => (
                        <VisibilitySensor partialVisibility onChange={isVisible => {
                            if(isVisible && !this.state.animated) {
                                this.setState({ animated: true })
                                start()
                            }
                        }} delayedCall>
                            <span ref={countUpRef} />
                        </VisibilitySensor>
                    )}
                </CountUp>
            </div>
            <div className="description">{this.props.description}</div>
        </div>
    }
}
